import React, { HTMLInputTypeAttribute, SetStateAction, useEffect, useState } from 'react'
import "./Holiday.min.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, Outlet } from 'react-router-dom';
import { AiOutlineClose, AiOutlineAppstoreAdd, AiFillEdit, AiFillDelete, } from 'react-icons/ai';
import { ipAddress } from '../../ipAddress'
import axios from 'axios';
import { IoMdAddCircle } from 'react-icons/io';




interface Holiday {
  User: string,
  Holiday_name: string,
  Days: number,
  Id: number,
  Data: string,
  Date_Of_Birth: Date,
  Name_Of_Child: string,
  Data_Update: string,
  UsedDays: number,
}
interface NewYear {
  Id: number,
  DataUpdate: number,
  Updated: boolean,
  Updated2: boolean
}
interface DefaultList {
  Id: number,
  User: string,
  Name: string,
  Date: string,
  Holiday_date: string,
  Date_add: string,
  Year: string,
  Date_update: string,
  Updated: boolean,

}
interface User {
  Id: number,
  Name: string,
  Login: string,
  Password: string,
  UpdateNewYear: boolean,
  Added: string,
  Access: string
}
interface Planned {
  Id: number,
  User: string,
  Holiday_name: string,
  Start_holiday: string,
  End_holiday: string,
  Name_Of_Child: string,
  All_Days: number,
  Weeks_Days: number,
  Weekend_Days: number,
  Holiday_days: number,
  Data: string,

}


const Holiday: React.FC = (Holiday, NewYear) => {

  const [userName, setUserName] = useState<string>('Przemek');
  const [overdue, setOverdue] = useState<number>();
  const [usedOverdue, setUsedOverdue] = useState<number>();
  const [due, setDue] = useState<number>()
  const [usedDue, setUsedDue] = useState<number>()
  const [planned, setPlanned] = useState<number>();
  const [used, setUsed] = useState<number>();
  const [remaining, setRemaining] = useState<number>();
  const [addFreeDays, setAddFreeDays] = useState<boolean>(false);
  const [freeDays, setFreeDays] = useState<string>('');
  const [nameHoliday, setNameHoliday] = useState<string>('');
  const [addOverdueDays, setAddOverdueDays] = useState<boolean>(false);
  const [editOverdueDays, setEditOverdueDays] = useState<boolean>(false);
  const [deleteOverdueDays, setDeleteOverdueDays] = useState<boolean>(false);
  const [overdueDays, setOverdueDays] = useState<string>('Zwykły urlop');
  const [numberOverdueDays, setNumberOverdueDays] = useState<string>();
  const [numberOverdueDays2, setNumberOverdueDays2] = useState<string>('10');
  const [updateOverdueDays, setUpdateOverdueDays] = useState<Holiday[]>([]);
  const [updateOverdueDays3, setUpdateOverdueDays3] = useState<Holiday[]>([]);
  const [editNameOverdueDays, setEditNameOverdueDays] = useState<string>('');
  const [editIdOverdueDays, setEditIdOverdueDays] = useState<string>('');
  const [editNumberOverdueDays, setEditNumberOverdueDays] = useState<string>('');
  const [editNumberOverdueDays2, setEditNumberOverdueDays2] = useState<string>('');
  const [deleteNameOverdueDays, setDeleteNameOverdueDays] = useState<string>('');
  const [deleteIdOverdueDays, setDeleteIdOverdueDays] = useState<string>('');

  const [addDueDays, setAddDueDays] = useState<boolean>(false);
  const [editDueDays, setEditDueDays] = useState<boolean>(false);
  const [deleteDueDays, setDeleteDueDays] = useState<boolean>(false);
  const [dueDays, setDueDays] = useState<string>('Zwykły urlop');
  const [numberDueDays, setNumberDueDays] = useState<string>('2');
  const [numberDueDays2, setNumberDueDays2] = useState<string>('10');
  const [updateDueDays, setUpdateDueDays] = useState<Holiday[]>([]);
  const [updateDueDays3, setUpdateDueDays3] = useState<Holiday[]>([]);
  const [editNameDueDays, setEditNameDueDays] = useState<string>('');
  const [editIdDueDays, setEditIdDueDays] = useState<string>('');
  const [editNumberDueDays, setEditNumberDueDays] = useState<string>('');
  const [editNumberDueDays2, setEditNumberDueDays2] = useState<string>('');
  const [deleteNameDueDays, setDeleteNameDueDays] = useState<string>('');
  const [deleteIdDueDays, setDeleteIdDueDays] = useState<string>('');
  const [newYear, setNewYear] = useState<NewYear[]>([])
  const [nameOfChildDue, setNameOfChildDue] = useState<string>("")
  const [editNameOfChildDue, setEditNameOfChildDue] = useState<string>("")
  const [nameOfChildOverdue, setNameOfChildOverdue] = useState<string>("")
  const [editNameOfChildOverdue, setEditNameOfChildOverdue] = useState<string>("")
  const [dateOfBirth, setDateOfBirth] = useState<string>('')
  const [editDateOfBirthDue, setEditDateOfBirthDue] = useState<string>('')
  const [dateOfBirthOverdue, setDateOfBirthOverdue] = useState<string>('')
  const [editDateOfBirthOverdue, setEditDateOfBirthOverdue] = useState<string>('')

  // Planned Holiady
  const [editPlannedDays, setEditPlannedDays] = useState<boolean>(false);
  const [deletePlannedDays, setDeletePlannedDays] = useState<boolean>(false);
  const [addPlannedDays, setAddPlannedDays] = useState<boolean>(false);
  const [plannedDaysName, setPlannedDaysName] = useState<string>('');
  const [editPlannedDaysName, setEditPlannedDaysName] = useState<string>('');
  const [deletePlannedDaysName, setDeletePlannedDaysName] = useState<string>('');
  const [numberPlannedDays, setNumberPlannedDays] = useState<string>('2');
  const [numberPlannedDays2, setNumberPlannedDays2] = useState<string>('10');
  const [updateDataPlanned, setUpdateDataPlanned] = useState<Holiday[]>([]);
  const [numbersOfDaysPlanned, setNumbersOfDaysPlanned] = useState<string>('');
  const [editNumbersOfDaysPlanned, setEditNumbersOfDaysPlanned] = useState<string>('');
  const [startOfPlannedHolidays, setStartOfPlannedHolidays] = useState<string>('');
  const [endOfPlannedHolidays, setEndOfPlannedHolidays] = useState<string>('');
  const [editStartOfPlannedHolidays, setEditStartOfPlannedHolidays] = useState<string>('');
  const [editEndOfPlannedHolidays, setEditEndOfPlannedHolidays] = useState<string>('');
  const [deleteStartOfPlannedHolidays, setDeleteStartOfPlannedHolidays] = useState<string>('');
  const [deleteEndOfPlannedHolidays, setDeleteEndOfPlannedHolidays] = useState<string>('');
  const [nameOfChildPlanned, setNameOfChildPlanned] = useState<string>("");
  const [editNameOfChildPlanned, setEditNameOfChildPlanned] = useState<string>("");
  const [deleteNameOfChildPlanned, setDeleteNameOfChildPlanned] = useState<string>("");
  //const [weekendDays, setWeekendDays] = useState<[]>([]);
  const [holidayDays2, setHolidayDays2] = useState<DefaultList[]>([]);
  const [holidayDays3, setHolidayDays3] = useState<DefaultList[]>([]);
  const [menuOverdueDays, setMenuOverdueDays] = useState<boolean>(false);
  const [menuDueDays, setMenuDueDays] = useState<boolean>(false);
  const [menuPlannedDays, setMenuPlannedDays] = useState<boolean>(false);

  const [addUserHoliday, setAddUserHoliday] = useState<boolean>(false);
  const [editUserHoliday, setEditUserHoliday] = useState<boolean>(false);
  const [yearListOfHoliday, setYearListOfHoliday] = useState<string>();
  const [userDate, setUserDate] = useState<string>('');
  const [editUserDate, setEditUserDate] = useState<string>('');
  const [userNameHoliday, setUserNameHoliday] = useState<string>('');
  const [menuHolidays, setMenuHolidays] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [plannedDownload, setPlannedDownload] = useState<Planned[]>([]);

  const [plannedDays, setPlannedDays] = useState([]);
  const [plannedListName, setPlannedListName] = useState([]);
  const [plannedList, setPlannedList] = useState<Planned[]>([]);

  const [editId, setEditId] = useState<number>(0);
  const [deleteId, setDeleteId] = useState<number>(0);
  const [deleteIdAlert, setDeleteIdAlert] = useState<number>(0);
  const [idAlertEdit, setIdAlertEdit] = useState<number>(0);

  const [alertUsedDays, setAlertUsedDays] = useState<boolean>(false);
  const [alertUsedDays2, setAlertUsedDays2] = useState<number>(0);

  const [alertUsedDaysName, setAlertUsedDaysName] = useState<string>('')
  const [alertUsedStartOfPlannedHolidays, setAlertUsedStartOfPlannedHolidays] = useState<string>('')
  const [alertUsedEndOfPlannedHolidays, setAlertUsedEndOfPlannedHolidays] = useState<string>('')
  const [alertUsedNameOfChildPlanned, setAlertUsedNameOfChildPlanned] = useState<string>('')
  const [alertUsedWeeksDays, setAlertUsedWeeksDays] = useState<number>(0);
  const [alertUsedHolidayDays, setAlertUsedHolidayDays] = useState<number>(0);
  const [alertUsedAllDays, setAlertUsedAllDays] = useState<number>(0);
  const [alertUsedWeekendDays, setAlertUsedWeekendDays] = useState<number>(0);
  const [editNumbersOfDaysPlannedAlert, setEditNumbersOfDaysPlannedAlert] = useState<string>('');


  //Used Holiday
  const [usedDownload, setUsedDownload] = useState<Planned[]>([]);
  const [usedListName, setUsedListName] = useState([]);
  const [editNameOfChildUsed, setEditNameOfChildUsed] = useState<string>("");
  const [editUsedDaysName, setEditUsedDaysName] = useState<string>('');
  const [editStartOfUsedHolidays, setEditStartOfUsedHolidays] = useState<string>('');
  const [editEndOfUsedHolidays, setEditEndOfUsedHolidays] = useState<string>('');
  const [editUsedDays, setEditUsedDays] = useState<boolean>(false);
  const [editNumbersOfDaysUsed, setEditNumbersOfDaysUsed] = useState<string>('');
  const [editIdUsed, setEditIdUsed] = useState<number>(0);
  const [deleteIdUsed, setDeleteIdUsed] = useState<number>(0);
  const [deleteUsedDaysName, setDeleteUsedDaysName] = useState<string>('');
  const [deleteNameOfChildUsed, setDeleteNameOfChildUsed] = useState<string>("");
  const [deleteStartOfUsedHolidays, setDeleteStartOfUsedHolidays] = useState<string>('');
  const [deleteEndOfUsedHolidays, setDeleteEndOfUsedHolidays] = useState<string>('');
  const [deleteUsedDays, setDeleteUsedDays] = useState<boolean>(false);
  const [addUsedDays, setAddUsedDays] = useState<boolean>(false);
  const [startOfUsedHolidays, setStartOfUsedHolidays] = useState<string>('');
  const [endOfUsedHolidays, setEndOfUsedHolidays] = useState<string>('');
  const [usedDaysName, setUsedDaysName] = useState<string>('');
  const [numbersOfDaysUsed, setNumbersOfDaysUsed] = useState<string>('');
  const [nameOfChildUsed, setNameOfChildUsed] = useState<string>("");
  const [yearListOfHolidayUsed, setYearListOfHolidayUsed] = useState<string>();
  const [listMonthUsedHoliday, setListMonthUsedHoliday] = useState<string>('12');
  const [editUsedPlannedDays, setEditUsedPlannedDays] = useState<boolean>(false);
  const [countEndOfTheYear, setCountEndOfTheYear] = useState<number>(0)



  // Create USER
  const addUser = () => {
    axios.post(ipAddress + '/createUser', {
      Name: 'Przemek',
      Added: date,
      UpdateNewYear: false,
    })
  }




  let userEditHoliday = [];
  let day = new Date().getDate();
  let month = new Date().getMonth() + 1;
  let year = new Date().getFullYear();


  const yearListOfHoliday2 = () => {
    setYearListOfHoliday(year.toLocaleString())
  }
  useEffect(() => {
    yearListOfHoliday2();


  }, [])


  let month2: string;
  if (month < 10) {
    month2 = '0' + month
  } else {
    month2 = month.toString();
  }
  let day2: string;
  if (day < 10) {
    day2 = '0' + day
  } else {
    day2 = day.toString();
  }


  let date = year + '-' + month2 + '-' + day2



  // Add date to New Year, button reset
  const add = () => {
    axios.post(ipAddress + '/addNewYear', {
      newDate: year,
      updated: false,
      updated2: false
    })
    console.log('Update done')
  }


  // download date 


  const updateNewYear = () => {
    axios.post(ipAddress + '/updateNewYear', {
    })
      .then(response => {
        setNewYear(response.data)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    updateNewYear();

  }, [])



  const downloadUsers = () => {
    axios.post(ipAddress + '/downloadUsers', {
    })
      .then(response => {
        setUsers(response.data)


      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    downloadUsers();

  }, [])

  //console.log(users)

  // update date after new year
  const changeNewYear = () => {

    if (day == 30 && month == 1) {

      if (newYear[0].DataUpdate != year) {

        axios.post(ipAddress + '/changeNewYear', {
          newDate: year,
          updated: false,
          updated2: false,
        })

        updateNewYear();


      }
      if (newYear[0].DataUpdate == year) {
        addHolidaysTogether();
        updateHolidayAll();

      }

    }
  }

  useEffect(() => {
    if (newYear.length > 0) {
      changeNewYear();
    }
  }, [newYear])


  // Obliczanie daty kiedy przypadnie wielkanoc

  let yearNew = year + 1;

  let newYearDate = yearNew + '-' + '01' + '-' + '01';
  let threKings = yearNew + '-' + '01' + '-' + '06';
  let easterYearMonthDay;
  let easterMondayYearMonthDay;
  let firstOfMay = yearNew + '-' + '05' + '-' + '01';
  let thirdOfMay = yearNew + '-' + '05' + '-' + '03';
  let godsBodyYearMonthDay;
  let polishTroopsFestival = yearNew + '-' + '08' + '-' + '15';
  let allTheSaints = yearNew + '-' + '11' + '-' + '01';
  let independenceDay = yearNew + '-' + '11' + '-' + '11';
  let christmas = yearNew + '-' + '12' + '-' + '25';
  let secondDayOfChristmas = yearNew + '-' + '12' + '-' + '26';


  let a = yearNew % 19;
  let b = Math.floor(2024 / 100)
  let c = yearNew % 100
  let d = Math.floor(b / 4)
  let e = b % 4
  let f = Math.floor((b + 8) / 25)
  let g = Math.floor((b - f + 1) / 3)
  let h = (19 * a + b - d - g + 15) % 30
  let i = Math.floor(c / 4)
  let k = c % 4
  let l = (32 + 2 * e + 2 * i - h - k) % 7
  let m = Math.floor(((a + 11 * h + 22 * l)) / 451)
  let o = (h + l - 7 * m + 114) % 31
  let p = o + 1;
  let r: string;
  if (p < 10) {
    r = '0' + p
  } else {
    r = p.toString()
  }

  let easterMonth;
  let easterDay;

  easterDay = r;

  let s = Math.floor((h + l - 7 * m + 114) / 31)
  let t: string;
  if (s < 10) {
    t = '0' + s
  } else {
    t = s.toString()
  }

  easterMonth = t;
  easterYearMonthDay = yearNew + '-' + easterMonth + '-' + easterDay;

  let easterMonday = new Date(easterYearMonthDay)
  easterMonday.setDate(easterMonday.getDate() + 1)

  let easterMondayDay = easterMonday.getDate()
  let easterMondayDay1;
  if (easterMondayDay < 10) {
    easterMondayDay1 = '0' + easterMondayDay
  } else {
    easterMondayDay1 = easterMondayDay
  }

  let easterMondayMonth = easterMonday.getMonth() + 1
  let easterMondayMonth1;
  if (easterMondayMonth < 10) {
    easterMondayMonth1 = '0' + easterMondayMonth
  } else {
    easterMondayMonth1 = easterMondayMonth
  }
  easterMondayYearMonthDay = yearNew + '-' + easterMondayMonth1 + '-' + easterMondayDay1;

  let godsBody = new Date(easterYearMonthDay)
  godsBody.setDate(godsBody.getDate() + 60)

  let godsBodyDay = godsBody.getDate()
  let godsBodyDay1;
  if (godsBodyDay < 10) {
    godsBodyDay1 = '0' + godsBodyDay
  } else {
    godsBodyDay1 = godsBodyDay
  }

  let godsBodyMonth = godsBody.getMonth() + 1
  let godsBodyMonth1;
  if (godsBodyMonth < 10) {
    godsBodyMonth1 = '0' + godsBodyMonth
  } else {
    godsBodyMonth1 = godsBodyMonth
  }
  godsBodyYearMonthDay = yearNew + '-' + godsBodyMonth1 + '-' + godsBodyDay1;

  //lista wszystkich świąt 

  let holidayDaysList = [];
  holidayDaysList.push(
    { name: 'Nowy Rok', date: newYearDate },
    { name: 'Święto trzech Kóli', date: threKings },
    { name: 'Niedziela Wielkanocna', date: easterYearMonthDay },
    { name: 'Poniedziałek Wielkanocny', date: easterMondayYearMonthDay },
    { name: '1 maja', date: firstOfMay },
    { name: '3 maja', date: thirdOfMay },
    { name: 'Boże Ciało', date: godsBodyYearMonthDay },
    { name: 'Święto Wojska Polskiego', date: polishTroopsFestival },
    { name: 'Wszystkich Świętych', date: allTheSaints },
    { name: 'Święto Niepodległości', date: independenceDay },
    { name: 'Boże Narodzenie (pierwszy dzień)', date: christmas },
    { name: 'Boże Narodzenie (drugi dzień)', date: secondDayOfChristmas }

  )

  // dodawanie wspólnych świąt

  const addHolidaysTogether = () => {

    if (newYear[0].Updated2 == false) {

      for (let i = 0; i < holidayDaysList.length; i++) {
        axios.post(ipAddress + '/addHolidaysTogether', {
          User: 'Together',
          Name: holidayDaysList[i].name,
          Year: yearNew,
          Date: '',
          Holiday_date: holidayDaysList[i].date,
          Date_add: date,
          Updated: false,
        })
      }
      axios.post(ipAddress + '/changeNewYear3', {
        updated: true
      })
    }
  }


  // pobieranie wspólnych świąt

  const holidaysDownload = () => {
    axios.post(ipAddress + '/holidaysDownload', {
      User: 'Together',
      User2: userName,
      Year: yearListOfHoliday,
      Year2:Number(yearListOfHoliday) + 1 ,
      Year3:Number(yearListOfHoliday) - 1 ,
    })
      .then(response => {
        setHolidayDays2(response.data)
       
      })
      .catch(err => {

        console.log(err)

      })
  }
  useEffect(() => {
    holidaysDownload();


  }, [yearListOfHoliday, holidayDays2, editUserHoliday, addUserHoliday])
  
  // Pobiera dni swiąteczne do zakładki dni świąteczne. Tylko tutaj potrzebne.

  const holidaysDownload2 = () => {
    axios.post(ipAddress + '/holidaysDownload2', {
      User: 'Together',
      User2: userName,
      Year: yearListOfHoliday,
    })
      .then(response => {
        setHolidayDays3(response.data)
       
      })
      .catch(err => {

        console.log(err)

      })
  }
  useEffect(() => {
    holidaysDownload2();


  }, [yearListOfHoliday, holidayDays2, editUserHoliday, addUserHoliday])



  const overdueHoliday = () => {
    let overdue = document.getElementById('overdue');
    overdue.classList.toggle('visible')
    overdue.classList.toggle('notVisible')
  }
  const dueHoliday = () => {
    let due = document.getElementById('due');
    due.classList.toggle('visible')
    due.classList.toggle('notVisible')
  }
  const plannedHoliday = () => {
    let planned = document.getElementById('planned');

    planned.classList.toggle('notVisible');

    let all = document.getElementsByClassName('listPlannedHoliday');
    for (let i = 0; i < all.length; i++) {
      all[i].classList.add('notVisible')

    }



  }


  const usedHoliday = () => {
    let used = document.getElementById('used');
    used.classList.toggle('visible')
    used.classList.toggle('notVisible')

    let all = document.getElementsByClassName('listUsedHoliday');
    for (let i = 0; i < all.length; i++) {
      all[i].classList.add('notVisible')

    }

  }
  const remainingHoliday = () => {
    let remaining = document.getElementById('remaining');
    remaining.classList.toggle('visible')
    remaining.classList.toggle('notVisible')
    let defaultList = document.getElementById('defaultList');

  }
  const listHolidays = () => {
    let list = document.getElementById('holidayList');
    list.classList.toggle('visible');
    list.classList.toggle('notVisible');


  }

  ///////////////////////////////////////////////////////////////////////////
  // poniższa funckja nie działa
  const addHoliday2 = (e: React.FormEvent) => {
    e.preventDefault();
    setAddFreeDays(false);
    let due = document.getElementById('due');
    due.classList.toggle('visible')
    due.classList.toggle('notVisible')
  }



  const OverdueDays2 = (e: React.FormEvent) => {
    e.preventDefault();


    if (overdueDays === 'Zwykły urlop') {
      let dane = updateOverdueDays.filter(date => date.User === userName && date.Holiday_name === overdueDays)


      if (dane.length > 0) {

        let alert = document.getElementById('alertOverdue');
        alert.textContent = "Urlop o takiej nazwie już istnieje"

      }
      else {

        axios.post(ipAddress + '/addOverdueVacation', {
          User: userName,
          HolidayName: overdueDays,
          Days: numberOverdueDays,
          Data: date,
          UsedDays: 0,
          DateOfBirth: '',
          NameOfChild: ''

        })
        setAddOverdueDays(false);
        setOverdueDays("Zwykły urlop");
        setNumberOverdueDays('2');
        setMenuOverdueDays(false);




      }


    }

    else if (overdueDays === "Urlop ojcowski") {
      axios.post(ipAddress + '/addOverdueVacation', {
        User: userName,
        HolidayName: overdueDays,
        Days: numberOverdueDays2,
        Data: date,
        UsedDays: 0,
        DateOfBirth: dateOfBirthOverdue,
        NameOfChild: nameOfChildOverdue

      })
      setAddOverdueDays(false);
      setOverdueDays("Zwykły urlop");
      setNumberOverdueDays('2')
      setMenuOverdueDays(false)

    }

  }

  const resetAlertOverdue = () => {
    let alert = document.getElementById('alertOverdue');
    alert.textContent = ""
  }

  const overdueDaysUpdate = () => {
    axios.post(ipAddress + '/OverdueDaysUpdate', {
      User: userName,

    })
      .then(response => {
        setUpdateOverdueDays(response.data)
        // console.log(response.data)


      })
      .catch(err => {

        console.log(err)

      })

  }

  useEffect(() => {
    overdueDaysUpdate();
  }, [updateOverdueDays, userName])

  const updateHolidayAll = () => {

    axios.post(ipAddress + '/DueDaysUpdate4', {

    })
      .then(response => {
        setUpdateDueDays3(response.data)

      })
      .catch(err => {

        console.log(err)

      })


    axios.post(ipAddress + '/OverdueDaysUpdate4', {

    })
      .then(response => {
        setUpdateOverdueDays3(response.data)

      })
      .catch(err => {

        console.log(err)

      })


  }
  //console.log(updateOverdueDays3)
  useEffect(() => {
    if (updateOverdueDays3.length > 0) {
      nowyRok();
    }

  }, [updateOverdueDays3])

  const overdueDaysEdit = (e: React.FormEvent) => {
    e.preventDefault();


    if (editNameOverdueDays == "Zwykły urlop") {

      axios.post(ipAddress + '/overdueVacationEdit', {
        HolidayName: editNameOverdueDays,
        Days: editNumberOverdueDays,
        Data_Update: date,
        DateOfBirth: '',
        NameOfChild: '',
        Id: editIdOverdueDays

      })

    } else if (editNameOverdueDays == "Urlop ojcowski") {
      axios.post(ipAddress + '/overdueVacationEdit', {
        HolidayName: editNameOverdueDays,
        Days: editNumberOverdueDays2,
        Data_Update: date,
        DateOfBirth: editDateOfBirthOverdue,
        NameOfChild: editNameOfChildOverdue,
        Id: editIdOverdueDays

      })

    }
    setEditOverdueDays(false);
    setMenuOverdueDays(false)
  }


  const overdueDaysDelete = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(ipAddress + '/overdueVacationDelete', {
      Id: deleteIdOverdueDays
    })
    setDeleteOverdueDays(false);
    setMenuOverdueDays(false)

  }





  const allOverdueDays = () => {
    let allOverdueDays: number = 0;
    let allUsedOverdueDays: number = 0;

    //console.log(updateOverdueDays)

    for (let i = 0; i < updateOverdueDays.length; i++) {
      allOverdueDays += updateOverdueDays[i].Days


    }
    for (let i = 0; i < updateOverdueDays.length; i++) {
      allUsedOverdueDays += updateOverdueDays[i].UsedDays
      //console.log(updateOverdueDays[i])

    }
    //console.log(allUsedOverdueDays)


    setOverdue(allOverdueDays)
    setUsedOverdue(allUsedOverdueDays)
  }

  useEffect(() => {
    allOverdueDays();
  }, [updateOverdueDays])





  const addOptions = () => {

    if (updateOverdueDays.length > 0) {
      setEditNameOverdueDays(updateOverdueDays[0].Holiday_name)
      setEditIdOverdueDays((updateOverdueDays[0].Id).toString())
      let select = document.getElementById('editListOverdueHolidays');

      for (let i = 0; i < updateOverdueDays.length; i++) {
        let option = document.createElement("option");
        option.textContent = updateOverdueDays[i].Holiday_name + " " + updateOverdueDays[i].Name_Of_Child
        option.setAttribute('value', (updateOverdueDays[i].Id).toString())
        select.appendChild(option)

      }
    }


  }

  useEffect(() => {
    if (editOverdueDays === true) {
      //addOptions()
    }

  }, [editOverdueDays])

  const addOptionss2 = () => {

    setEditNameOverdueDays(updateOverdueDays[0].Holiday_name)
    setEditIdOverdueDays((updateOverdueDays[0].Id).toString())
    let tab = [];


    for (let i = 0; i < updateOverdueDays.length; i++) {
      tab.push(updateOverdueDays[i].Holiday_name)
    }

    let tab4 = tab.filter((item, index, array) => array.indexOf(item) === index);
    let select = document.getElementById('editListOverdueHolidays');
    if (tab4.length > 0) {

      setPlannedDaysName(tab4[0]);
      for (let i = 0; i < tab4.length; i++) {
        let option = document.createElement("option");
        option.textContent = tab4[i];
        select.appendChild(option);
        option.setAttribute('value', tab4[i]);

      }
    }
  }


  useEffect(() => {
    if (editOverdueDays === true) {
      addOptionss2()
    }

  }, [editOverdueDays])


  const addOptionsInSelectDelete = () => {
    if (updateOverdueDays.length > 0) {
      setDeleteNameOverdueDays(updateOverdueDays[0].Holiday_name)
      setDeleteIdOverdueDays((updateOverdueDays[0].Id).toString())
      let select = document.getElementById('deleteListOverdueHolidays');
      for (let i = 0; i < updateOverdueDays.length; i++) {
        let option = document.createElement("option");
        option.textContent = updateOverdueDays[i].Holiday_name;
        option.setAttribute('value', (updateOverdueDays[i].Id).toString())
        select.appendChild(option)
      }
    }

  }

  useEffect(() => {
    if (deleteOverdueDays === true) {
      // addOptionsInSelectDelete()
    }

  }, [deleteOverdueDays])

  const addOptionsInSelectDelete3 = () => {
    setDeleteNameOverdueDays(updateOverdueDays[0].Holiday_name)
    setDeleteIdOverdueDays((updateOverdueDays[0].Id).toString())
    let tab = [];

    for (let i = 0; i < updateOverdueDays.length; i++) {
      tab.push(updateOverdueDays[i].Holiday_name)
    }

    let tab4 = tab.filter((item, index, array) => array.indexOf(item) === index);
    let select = document.getElementById('deleteListOverdueHolidays');
    if (tab4.length > 0) {

      for (let i = 0; i < tab4.length; i++) {
        let option = document.createElement("option");
        option.textContent = tab4[i];
        select.appendChild(option);
        option.setAttribute('value', tab4[i]);

      }
    }


  }

  useEffect(() => {
    if (deleteOverdueDays === true) {
      addOptionsInSelectDelete3()
    }

  }, [deleteOverdueDays])


  const deleteOverdueHoliday2 = (e: React.FormEvent) => {
    e.preventDefault();
    let nameHoliday = document.getElementById('deleteListOverdueHolidays') as HTMLInputElement
    let nameHoliday2 = nameHoliday.value
    setDeleteNameOverdueDays(nameHoliday2)


    if (nameHoliday2 == "Zwykły urlop") {
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if ((updateOverdueDays[i].Holiday_name).toString() === nameHoliday2) {
          setDeleteIdOverdueDays((updateOverdueDays[i].Id).toString())
          console.log((updateOverdueDays[i].Id).toString())
        }
      }
    }




  }

  const deleteOverdueHoliday3 = (e: React.FormEvent) => {
    e.preventDefault();
    let idHoliday = document.getElementById('deleteNameOfChildOverdue2') as HTMLInputElement

    let idHoliday2 = idHoliday.value;
    setDeleteIdOverdueDays(idHoliday2);
  }



  // Due Days
  const dueDays2 = (e: React.FormEvent) => {
    e.preventDefault();

    if (dueDays === 'Zwykły urlop' || dueDays === 'Urlop opiekuńczy') {

      let dane = updateDueDays.filter(date => date.User === userName && date.Holiday_name === dueDays)
      if (dane.length > 0) {

        let alert = document.getElementById('alertDue');
        alert.textContent = "Urlop o takiej nazwie już istnieje"
      }

      else {

        if (dueDays == "Urlop opiekuńczy") {
          axios.post(ipAddress + '/addDueVacation', {
            User: userName,
            HolidayName: dueDays,
            Days: numberDueDays,
            UsedDays: 0,
            Data: date,
            DateOfBirth: '',
            NameOfChild: ''

          })
          setAddDueDays(false);
          setDueDays("Zwykły urlop");
          setNumberDueDays('2')
          setMenuDueDays(false)

        } else if (dueDays == "Zwykły urlop") {
          axios.post(ipAddress + '/addDueVacation', {
            User: userName,
            HolidayName: dueDays,
            Days: numberDueDays,
            Data: date,
            UsedDays: 0,
            DateOfBirth: '',
            NameOfChild: ''

          })
          setAddDueDays(false);
          setDueDays("Zwykły urlop");
          setNumberDueDays('2')
          setMenuDueDays(false)

        }
      }
    }
    else if (dueDays == "Urlop ojcowski") {
      axios.post(ipAddress + '/addDueVacation', {
        User: userName,
        HolidayName: dueDays,
        Days: numberDueDays2,
        Data: date,
        UsedDays: 0,
        DateOfBirth: dateOfBirth,
        NameOfChild: nameOfChildDue

      })

      setAddDueDays(false);
      setDueDays("Zwykły urlop");
      setNumberDueDays('2')
      setMenuDueDays(false)



    }



  }



  const resetAlertDue = () => {
    let alert = document.getElementById('alertDue');
    alert.textContent = ""
  }

  const dueDaysEdit = (e: React.FormEvent) => {
    e.preventDefault();


    if (editNameDueDays == "Urlop opiekuńczy") {
      axios.post(ipAddress + '/dueVacationEdit', {
        HolidayName: editNameDueDays,
        Days: editNumberDueDays,
        Data_Update: date,
        DateOfBirth: '',
        NameOfChild: '',
        Id: editIdDueDays

      })
    } else if (editNameDueDays == "Zwykły urlop") {

      axios.post(ipAddress + '/dueVacationEdit', {
        HolidayName: editNameDueDays,
        Days: editNumberDueDays,
        Data_Update: date,
        DateOfBirth: '',
        NameOfChild: '',
        Id: editIdDueDays



      })

    } else if (editNameDueDays == "Urlop ojcowski") {
      axios.post(ipAddress + '/dueVacationEdit', {
        HolidayName: editNameDueDays,
        Days: editNumberDueDays2,
        Data_Update: date,
        DateOfBirth: editDateOfBirthDue,
        NameOfChild: editNameOfChildDue,
        Id: editIdDueDays
      })

    }
    setEditDueDays(false);
    setMenuDueDays(false);
    setEditNumberDueDays('');


  }


  const dueDaysDelete = (e: React.FormEvent) => {
    e.preventDefault();

    axios.post(ipAddress + '/dueVacationDelete', {
      Id: deleteIdDueDays
    })
    setDeleteDueDays(false);
    setMenuDueDays(false)

  }

  const dueDaysUpdate = () => {
    axios.post(ipAddress + '/dueDaysUpdate', {
      User: userName,

    })
      .then(response => {
        setUpdateDueDays(response.data)

      })
      .catch(err => {

        console.log(err)

      })

  }

  

  useEffect(() => {
    dueDaysUpdate();
  }, [updateDueDays, userName])

  const deleteDueHoliday2 = (e: React.FormEvent) => {
    e.preventDefault();
    let nameHoliday = document.getElementById('deleteListDueHolidays') as HTMLInputElement
    let nameHoliday2 = nameHoliday.value
    setDeleteNameDueDays(nameHoliday2)


    if (nameHoliday2 == "Zwykły urlop") {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Holiday_name).toString() === nameHoliday2) {
          setDeleteIdDueDays((updateDueDays[i].Id).toString())
          console.log((updateDueDays[i].Id).toString())
        }
      }
    }
    if (nameHoliday2 == "Urlop opiekuńczy") {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Holiday_name).toString() === nameHoliday2) {
          setDeleteIdDueDays((updateDueDays[i].Id).toString())
          console.log((updateDueDays[i].Id).toString())
        }
      }
    }

  }

  const deleteDueHoliday3 = (e: React.FormEvent) => {
    e.preventDefault();
    let idHoliday = document.getElementById('deleteNameOfChildDue2') as HTMLInputElement
    let idHoliday2 = idHoliday.value;
    setDeleteIdDueDays(idHoliday2);
  }



  const allDueDays = () => {
    let allDueDays: number = 0;
    let allUsedDueDays: number = 0;
    for (let i = 0; i < updateDueDays.length; i++) {
      allDueDays += updateDueDays[i].Days
    }
    for (let i = 0; i < updateDueDays.length; i++) {
      allUsedDueDays += updateDueDays[i].UsedDays
    }
    setDue(allDueDays)
    setUsedDue(allUsedDueDays)
  }

  useEffect(() => {
    allDueDays();
  }, [updateDueDays, userName])


  const allPlannedDays = () => {


    let plannedDaysAll1: number = 0;
    let plannedDaysAll2: number = 0;
    let plannedDaysAll3: number = 0;
    for (let i = 0; i < plannedDownload.length; i++) {

      if (plannedDownload[i].Holiday_name == 'Zwykły urlop') {

        plannedDaysAll1 += plannedDownload[i].Weeks_Days

      }
      if (plannedDownload[i].Holiday_name == 'Urlop ojcowski') {

        plannedDaysAll2 += plannedDownload[i].Weeks_Days

      }
      if (plannedDownload[i].Holiday_name == 'Urlop opiekuńczy') {

        plannedDaysAll3 += plannedDownload[i].Weeks_Days

      }

    }
    //if(plannedDaysAll1)
    // {updateOverdueDays.map((element) => <p className='overdueOne' key={element.Id}><span>  {element.Holiday_name + ' ' + element.Name_Of_Child + ':' + ' '} {element.Days - element.UsedDays} / {element.Days + ' dni'}</span></p>)}


  }

  useEffect(() => {
    allPlannedDays();
  }, [plannedListName, userName])



  const addOptions2 = () => {
    if (updateDueDays.length > 0) {
      setEditNameDueDays(updateDueDays[0].Holiday_name)
      setEditIdDueDays((updateDueDays[0].Id).toString())
      let select = document.getElementById('editListDueHolidays');
      for (let i = 0; i < updateDueDays.length; i++) {
        let option = document.createElement("option");
        option.textContent = updateDueDays[i].Holiday_name;
        option.setAttribute('value', (updateDueDays[i].Id).toString())
        select.appendChild(option)
      }
    }
  }



  useEffect(() => {
    if (editDueDays === true) {
      //addOptions2()
    }

  }, [editDueDays])


  const addOptionss4 = () => {

    setEditNameDueDays(updateDueDays[0].Holiday_name)
    setEditIdDueDays((updateDueDays[0].Id).toString())
    let tab = [];


    for (let i = 0; i < updateDueDays.length; i++) {
      tab.push(updateDueDays[i].Holiday_name)
    }

    let tab4 = tab.filter((item, index, array) => array.indexOf(item) === index);
    let select = document.getElementById('editListDueHolidays');
    if (tab4.length > 0) {


      for (let i = 0; i < tab4.length; i++) {
        let option = document.createElement("option");
        option.textContent = tab4[i];
        select.appendChild(option);
        option.setAttribute('value', tab4[i]);

      }
    }
  }


  useEffect(() => {
    if (editDueDays === true) {
      addOptionss4()
    }

  }, [editDueDays])



  const addOptionsInSelectDelete2 = () => {
    if (updateDueDays.length > 0) {
      setDeleteNameDueDays(updateDueDays[0].Holiday_name)
      setDeleteIdDueDays((updateDueDays[0].Id).toString())
      let select = document.getElementById('deleteListDueHolidays');
      for (let i = 0; i < updateDueDays.length; i++) {
        let option = document.createElement("option");
        option.textContent = updateDueDays[i].Holiday_name;
        option.setAttribute('value', (updateDueDays[i].Id).toString())
        select.appendChild(option)
      }
    }

  }



  useEffect(() => {
    if (deleteDueDays === true) {
      //addOptionsInSelectDelete2()
    }

  }, [deleteDueDays])

  const addOptionsInSelectDelete5 = () => {
    setDeleteNameDueDays(updateDueDays[0].Holiday_name)
    setDeleteIdDueDays((updateDueDays[0].Id).toString())
    let tab = [];

    for (let i = 0; i < updateDueDays.length; i++) {
      tab.push(updateDueDays[i].Holiday_name)
    }

    let tab4 = tab.filter((item, index, array) => array.indexOf(item) === index);
    let select = document.getElementById('deleteListDueHolidays');
    if (tab4.length > 0) {


      for (let i = 0; i < tab4.length; i++) {
        let option = document.createElement("option");
        option.textContent = tab4[i];
        select.appendChild(option);
        option.setAttribute('value', tab4[i]);

      }
    }


  }

  useEffect(() => {
    if (deleteDueDays === true) {
      addOptionsInSelectDelete5()
    }

  }, [deleteDueDays])








  const nowyRok = () => {

    //console.log(users)
    if (newYear[0].Updated != true) {
      for (let i = 0; i < users.length; i++) {
        if (users[i].UpdateNewYear == false) {
          axios.post(ipAddress + '/UpdateDueVacationNewYear', {
            User: users[i].Name,
            HolidayName: 'Urlop opiekuńczy',
          }
          )

          let overdueVacation: number = 0;
          let overdueFilter = updateOverdueDays3.filter(word => word.User == users[i].Name && word.Holiday_name == "Zwykły urlop")

          if (overdueFilter.length > 0) {
            overdueVacation = overdueFilter[0].Days
          }

          let dueVacation: number = 0;
          let dueFilter = updateDueDays3.filter(word => word.User == users[i].Name && word.Holiday_name == "Zwykły urlop")

          if (dueFilter.length > 0) {
            dueVacation = dueFilter[0].Days
          }

          let allDays = overdueVacation + dueVacation;

          axios.post(ipAddress + '/UpdateDueVacationNewYear2', {
            User: users[i].Name,
            HolidayName: 'Zwykły urlop',
            Days: allDays,
            Data: date,
            Data_Update: '',
          }
          )

          if (overdueFilter.length < 1) {
            axios.post(ipAddress + '/addOverdueVacation', {
              User: users[i].Name,
              HolidayName: "Zwykły urlop",
              Days: dueVacation,
              Data: date,
              DateOfBirth: '',
              NameOfChild: '',

            }
            )
          }

          //Urlop należny

          axios.post(ipAddress + '/UpdateDueVacationNewYear5', {
            User: users[i].Name,
            HolidayName: 'Zwykły urlop',
            Days: 26,
          }
          )

          // Urlop ojcowski
          let urlopOjcowskiDays: number;
          let urlopOjcowskiDate: string;
          let urlopOjcowskiDateUpdate: string;
          let urlopOjcowskiDateOfBirth: Date;
          let urlopOjcowskiNameOfChild: string;
          if (updateDueDays3.length > 0) {
            let dueFilterUrlopOjcowski = updateDueDays3.filter(word => word.User == users[i].Name && word.Holiday_name == "Urlop ojcowski")

            if (dueFilterUrlopOjcowski.length > 0) {
              for (let j = 0; j < dueFilterUrlopOjcowski.length; j++) {
                urlopOjcowskiDays = dueFilterUrlopOjcowski[j].Days
                urlopOjcowskiDate = dueFilterUrlopOjcowski[j].Data
                urlopOjcowskiDateOfBirth = dueFilterUrlopOjcowski[j].Date_Of_Birth
                urlopOjcowskiNameOfChild = dueFilterUrlopOjcowski[j].Name_Of_Child
                urlopOjcowskiDateUpdate = dueFilterUrlopOjcowski[j].Data_Update



                if (urlopOjcowskiDays > 0) {
                  let date1 = new Date(dueFilterUrlopOjcowski[j].Date_Of_Birth);
                  let date2 = new Date();
                  //var dateFormart = new Date(`"${month}/${day}/${year}"`);
                  let timeDiff = Math.abs(date2.getTime() - date1.getTime());
                  let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
                  if (diffDays < 365) {
                    axios.post(ipAddress + '/addOverdueVacation', {
                      User: users[i].Name,
                      HolidayName: 'Urlop ojcowski',
                      Days: urlopOjcowskiDays,
                      Data: urlopOjcowskiDate,
                      DateOfBirth: urlopOjcowskiDateOfBirth,
                      NameOfChild: urlopOjcowskiNameOfChild,
                      DataUpdate: urlopOjcowskiDateUpdate
                    })
                  }
                }
              }
            }
            //Urlop ojcowski , delete after new year

            axios.post(ipAddress + '/UpdateDueVacationNewYear4', {
              User: users[i].Name,
              HolidayName: 'Urlop ojcowski',
            })
          }
          // Urlop ojcowski, delete after one year 
          //var dateFormart = new Date(`"${month}/${day}/${year}"`);
          //Data w formacie takim jak wyżej albo tak jak w sql jako dana wejściowa
          //date i wtedy ma postać : xxxx-xx-xx

          if (updateOverdueDays3.length > 0) {
            let overdueFilterUrlopOjcowski2 = updateOverdueDays3.filter(word => word.User == users[i].Name && word.Holiday_name == "Urlop ojcowski")
            if (overdueFilterUrlopOjcowski2.length > 0) {
              for (let j = 0; j < overdueFilterUrlopOjcowski2.length; j++) {
                let date1 = new Date(overdueFilterUrlopOjcowski2[j].Date_Of_Birth);
                let date2 = new Date();
                //var dateFormart = new Date(`"${month}/${day}/${year}"`);
                let timeDiff = Math.abs(date2.getTime() - date1.getTime());
                let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));
                if (diffDays > 365) {
                  axios.post(ipAddress + '/overdueVacationDelete', {
                    Id: overdueFilterUrlopOjcowski2[j].Id
                  })
                }
              }
            }
          }
        }
      }

      axios.post(ipAddress + '/changeNewYear2', {
        updated: true
      })
    }
  }

  const closeAddDueVacation = () => {
    setAddDueDays(false);
    setDueDays("Zwykły urlop");
    setNumberDueDays('2')
  }

  const closeAddOverdueVacation = () => {
    setAddOverdueDays(false);
    setOverdueDays("Zwykły urlop");
  }


  const updateDueDays2 = () => {


    if (editNameDueDays == "Zwykły urlop") {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Id).toString() === editIdDueDays) {
          setEditNumberDueDays((updateDueDays[i].Days).toString())
        }
      }
    }
    if (editNameDueDays == 'Urlop ojcowski') {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Id).toString() === editIdDueDays) {
          setEditNumberDueDays2((updateDueDays[i].Days).toString())
          setEditNameOfChildDue(updateDueDays[i].Name_Of_Child)

          let a = updateDueDays[i].Date_Of_Birth
          let b = new Date(a).getFullYear();
          let c = new Date(a).getMonth() + 1;
          let d = new Date(a).getDate();
          let e: string

          let c1: string;
          if (c < 10) {
            c1 = '0' + c
          } else {
            c1 = c.toString();
          }

          let d1: string;
          if (d < 10) {
            d1 = '0' + d
          } else {
            d1 = d.toString();
          }


          e = (b + '-' + c1 + '-' + d1)
          setEditDateOfBirthDue(e)

        }
      }
    }
    if (editNameDueDays == "Urlop opiekuńczy") {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Id).toString() === editIdDueDays) {
          setEditNumberDueDays((updateDueDays[i].Days).toString())
        }
      }
    }




  }

  useEffect(() => {
    updateDueDays2()


  }, [editDueDays, editIdDueDays])



  const updateOverdueDays2 = () => {


    if (editNameOverdueDays == "Zwykły urlop") {
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if ((updateOverdueDays[i].Id).toString() === editIdOverdueDays) {
          setEditNumberOverdueDays((updateOverdueDays[i].Days).toString())
        }
      }
    }

    if (editNameOverdueDays == 'Urlop ojcowski') {
      for (let i = 0; i < updateOverdueDays.length; i++) {


        if ((updateOverdueDays[i].Id).toString() === editIdOverdueDays) {


          setEditNumberOverdueDays2((updateOverdueDays[i].Days).toString())
          setEditNameOfChildOverdue(updateOverdueDays[i].Name_Of_Child)

          let a = updateOverdueDays[i].Date_Of_Birth

          let b = new Date(a).getFullYear();
          let c = new Date(a).getMonth() + 1;
          let d = new Date(a).getDate();
          let e: string

          let c1: string;
          if (c < 10) {
            c1 = '0' + c
          } else {
            c1 = c.toString();
          }

          let d1: string;
          if (d < 10) {
            d1 = '0' + d
          } else {
            d1 = d.toString();
          }
          e = (b + '-' + c1 + '-' + d1)
          setEditDateOfBirthOverdue(e)

        }
      }
    }




  }

  useEffect(() => {
    updateOverdueDays2()


  }, [editOverdueDays, editIdOverdueDays])





  const editOverdueHoliday = (e: React.FormEvent) => {
    e.preventDefault();
    let id = document.getElementById('editListOverdueHolidays') as HTMLInputElement
    let id2 = id.value
    setEditIdOverdueDays(id2)
    console.log(id2)
    let name = document.getElementById('editListOverdueHolidays') as HTMLSelectElement
    let name2 = name.options[name.selectedIndex].text
    setEditNameOverdueDays(name2)
    console.log(name2)
  }

  const editOverdueHoliday2 = (e: React.FormEvent) => {
    e.preventDefault();
    let nameHoliday = document.getElementById('editListOverdueHolidays') as HTMLInputElement
    let nameHoliday2 = nameHoliday.value
    setEditNameOverdueDays(nameHoliday2)


    if (nameHoliday2 == "Zwykły urlop") {
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if ((updateOverdueDays[i].Holiday_name).toString() === nameHoliday2) {
          setEditIdOverdueDays((updateOverdueDays[i].Id).toString())
          console.log((updateOverdueDays[i].Id).toString())
        }
      }
    }


    console.log(nameHoliday2)
    let name = document.getElementById('editListOverdueHolidays') as HTMLSelectElement
    let name2 = name.options[name.selectedIndex].text

  }

  const editOverdueHoliday3 = (e: React.FormEvent) => {
    e.preventDefault();
    let idHoliday = document.getElementById('editNameOfChildOverdue2') as HTMLInputElement

    let idHoliday2 = idHoliday.value;
    setEditIdOverdueDays(idHoliday2);
  }


  const editDueHoliday = (e: React.FormEvent) => {
    e.preventDefault();
    let id = document.getElementById('editListDueHolidays') as HTMLInputElement
    let id2 = id.value
    setEditIdDueDays(id2)

    let name = document.getElementById('editListDueHolidays') as HTMLSelectElement
    let name2 = name.options[name.selectedIndex].text
    setEditNameDueDays(name2)
  }

  const editDueHoliday2 = (e: React.FormEvent) => {
    e.preventDefault();
    let nameHoliday = document.getElementById('editListDueHolidays') as HTMLInputElement
    let nameHoliday2 = nameHoliday.value
    setEditNameDueDays(nameHoliday2)


    if (nameHoliday2 == "Zwykły urlop") {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Holiday_name).toString() === nameHoliday2) {
          setEditIdDueDays((updateDueDays[i].Id).toString())
          console.log((updateDueDays[i].Id).toString())
        }
      }
    }
    if (nameHoliday2 == "Urlop opiekuńczy") {
      for (let i = 0; i < updateDueDays.length; i++) {
        if ((updateDueDays[i].Holiday_name).toString() === nameHoliday2) {
          setEditIdDueDays((updateDueDays[i].Id).toString())
          console.log((updateDueDays[i].Id).toString())
        }
      }
    }





  }

  const editDueHoliday3 = (e: React.FormEvent) => {
    e.preventDefault();
    let idHoliday = document.getElementById('editNameOfChildDue2') as HTMLInputElement

    let idHoliday2 = idHoliday.value;
    setEditIdDueDays(idHoliday2);
  }



  function getDatesInRange(startDate, endDate) {
    const date = startDate;

    const dates = [];

    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);

    }

    return dates;
  }

  const d1 = new Date('2022-01-18');
  const d2 = new Date('2022-01-24');

  getDatesInRange(d1, d2);






  const plannedDays2 = (e: React.FormEvent) => {
    e.preventDefault();


    let startTime = new Date(startOfPlannedHolidays)
    let endTime = new Date(endOfPlannedHolidays)

    let timeDiff = endTime.getTime() - startTime.getTime();
    let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

    

    if (diffDays < 0) {
      let alertPlanned2 = document.getElementById('alertPlanned2');
      alertPlanned2.textContent = "Zmień daty ! "
    } else {

      const dateStart = startTime;

      const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
      const weekendDays = [];
      const weeksDays = [];
      const togetherDays = [] // dni świąteczne
      const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
      const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
      const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

      // holidayDays2 - wszystkie dni swiąteczne togheter + User

      //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
      for (let i = 0; i < holidayDays2.length; i++) {
        if (holidayDays2[i].User == userName) {
          userDays.push(holidayDays2[i].Date)
        }
      }
      //Dodaje same dni świąteczne 
      for (let i = 0; i < holidayDays2.length; i++) {
        if (holidayDays2[i].User == 'Together') {
          togetherDays.push(holidayDays2[i].Holiday_date)
        }
      }





      // sprawdza czy jakiś dzień przepada w sobotę lub w niedzielę 

      while (dateStart <= endTime) {
        dates.push(new Date(dateStart));

        if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
          weekendDays.push(new Date(dateStart))
        } else (weeksDays.push(new Date(dateStart)))
        dateStart.setDate(dateStart.getDate() + 1);
      }


      // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
      weeksDays.filter(date => {

        for (let i = 0; i < userDays.length; i++) {
          if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
            holidayDays.push(new Date(userDays[i]).toLocaleDateString())
          }
        }


      })
      // Sprawdza czy któryś dzien w tygodniu przepada w święto
      weeksDays.filter(date => {

        for (let i = 0; i < togetherDays.length; i++) {
          if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
            holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
          }
        }


      })

      console.log(holidayDays3)


      // Odejmuje od wszystkich dni , dni przepadające w weekend, w święto i oddane za święto w sobotę.

      let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)

      if (daysHoliday !== 0) {

        if (plannedDaysName == "Zwykły urlop") {
          let alertPlanned = document.getElementById('alertPlanned');
          alertPlanned.textContent = '';
          let differentDaysOverdue: number = 0;
          let differentDaysDue: number = 0;
          for (let i = 0; i < updateDueDays.length; i++) {
            if (updateDueDays[i].Holiday_name == plannedDaysName) {
              let usedDays = updateDueDays[i].UsedDays
              console.log(usedDays)
              if (usedDays == undefined) {
                usedDays = 0
              }
              let days = updateDueDays[i].Days
              differentDaysDue = days - usedDays

            }
          }
          for (let i = 0; i < updateOverdueDays.length; i++) {
            if (updateOverdueDays[i].Holiday_name == plannedDaysName) {
              let usedDays = updateOverdueDays[i].UsedDays
              if (usedDays == undefined) {
                usedDays = 0
              }
              let days = updateOverdueDays[i].Days
              differentDaysOverdue = days - usedDays

            }
          }
          let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

          //sprawdza ile jest dni zaplanowanych 

          let plannedDaysAll: number = 0;

          for (let i = 0; i < plannedDownload.length; i++) {

            if (plannedDownload[i].Holiday_name == plannedDaysName) {

              plannedDaysAll += plannedDownload[i].Weeks_Days
            }


          }


          console.log(plannedDaysAll)

          // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
          let different = allDifferentDays - plannedDaysAll;


          if (different >= daysHoliday) {
            axios.post(ipAddress + '/addVacationPlanned', {
              User: userName,
              HolidayName: plannedDaysName,
              WeeksDays: daysHoliday,
              Data: date,
              HolidayDays: holidayDays.length + holidayDays3.length,
              NameOfChild: nameOfChildPlanned,
              StartHoliday: startOfPlannedHolidays,
              EndHoliday: endOfPlannedHolidays,
              AllDays: dates.length,
              WeekendDays: weekendDays.length,
            }
            )
            setAddPlannedDays(false);
            setPlannedDaysName("Zwykły urlop");
            setNumbersOfDaysPlanned("");
            setStartOfPlannedHolidays("");
            setEndOfPlannedHolidays("");
          }
          else {
            let alertPlanned = document.getElementById('alertPlanned');
            alertPlanned.textContent = 'Za dużo zaplanowanych dni'


          }

        }

        //////////////////////////////////////////////////////////////////////////////////////////////

        if (plannedDaysName == "Urlop ojcowski") {
          let alertPlanned = document.getElementById('alertPlanned');
          alertPlanned.textContent = ''
          let nameOfChildPlanned = document.getElementById('nameOfChildPlanned') as HTMLSelectElement
          let nameOfChildPlanned2 = nameOfChildPlanned.options[nameOfChildPlanned.selectedIndex].text
          let differentDaysOverdue: number = 0;
          let differentDaysDue: number = 0;


          for (let i = 0; i < updateDueDays.length; i++) {
            if (updateDueDays[i].Holiday_name == plannedDaysName && updateDueDays[i].Name_Of_Child == nameOfChildPlanned2) {
              let usedDays = updateDueDays[i].UsedDays

              if (usedDays == undefined) {
                usedDays = 0
              }
              let days = updateDueDays[i].Days
              differentDaysDue = days - usedDays

            }
          }


          for (let i = 0; i < updateOverdueDays.length; i++) {
            if (updateOverdueDays[i].Holiday_name == plannedDaysName && updateOverdueDays[i].Name_Of_Child == nameOfChildPlanned2) {
              let usedDays = updateOverdueDays[i].UsedDays
              if (usedDays == undefined) {
                usedDays = 0
              }
              let days = updateOverdueDays[i].Days
              differentDaysOverdue = days - usedDays

            }
          }


          let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

          let plannedDaysAll: number = 0;



          for (let i = 0; i < plannedDownload.length; i++) {

            if (plannedDownload[i].Holiday_name == plannedDaysName && plannedDownload[i].Name_Of_Child == nameOfChildPlanned2) {
              plannedDaysAll = plannedDownload[i].Weeks_Days
            }


          }

          let different = allDifferentDays - plannedDaysAll;

          if (daysHoliday == 5 || daysHoliday == 10) {

            if (different >= daysHoliday) {
              axios.post(ipAddress + '/addVacationPlanned', {
                User: userName,
                HolidayName: plannedDaysName,
                WeeksDays: daysHoliday,
                Data: date,
                HolidayDays: holidayDays.length,
                NameOfChild: nameOfChildPlanned2,
                StartHoliday: startOfPlannedHolidays,
                EndHoliday: endOfPlannedHolidays,
                AllDays: dates.length,
                WeekendDays: weekendDays.length,
              }
              )
              setAddPlannedDays(false);
              setPlannedDaysName("Zwykły urlop");
              setNumbersOfDaysPlanned("");
              setStartOfPlannedHolidays("");
              setEndOfPlannedHolidays("");

            }
            else {
              let alertPlanned = document.getElementById('alertPlanned');
              alertPlanned.textContent = 'Za dużo zaplanowanych dni'

            }
          } else {

            let alertPlanned = document.getElementById('alertPlanned');
            alertPlanned.textContent = 'Zaplanuj 5 lub 10 dni'
          }

        }

        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        if (plannedDaysName == "Urlop opiekuńczy") {
          let alertPlanned = document.getElementById('alertPlanned');
          alertPlanned.textContent = ''

          let yearOfCompletion = new Date(endOfPlannedHolidays)
     
          if (yearOfCompletion.getFullYear() > new Date().getFullYear()) {
            console.log('przyszły rok')
            let alertPlanned = document.getElementById('alertPlanned');
            alertPlanned.textContent = 'Ten urlop nie może być wykorzystany w przyszłym roku.'

          } else {


            if (daysHoliday == 1 || daysHoliday == 2) {

              let differentDaysDue: number = 0;

              for (let i = 0; i < updateDueDays.length; i++) {
                if (updateDueDays[i].Holiday_name == plannedDaysName) {
                  let usedDays = updateDueDays[i].UsedDays

                  if (usedDays == undefined) {
                    usedDays = 0
                  }
                  let days = updateDueDays[i].Days
                  differentDaysDue = days - usedDays

                }
              }
              console.log(differentDaysDue)

              let plannedDaysAll: number = 0;

              for (let i = 0; i < plannedDownload.length; i++) {

                if (plannedDownload[i].Holiday_name == plannedDaysName) {
                  plannedDaysAll = plannedDownload[i].Weeks_Days
                }


              }

              let different = differentDaysDue - plannedDaysAll;

              if (different >= daysHoliday) {
                axios.post(ipAddress + '/addVacationPlanned', {
                  User: userName,
                  HolidayName: plannedDaysName,
                  WeeksDays: daysHoliday,
                  Data: date,
                  HolidayDays: holidayDays.length,
                  NameOfChild: '',
                  StartHoliday: startOfPlannedHolidays,
                  EndHoliday: endOfPlannedHolidays,
                  AllDays: dates.length,
                  WeekendDays: weekendDays.length,
                }
                )
                setAddPlannedDays(false);
                setPlannedDaysName("Zwykły urlop");
                setNumbersOfDaysPlanned("");
                setStartOfPlannedHolidays("");
                setEndOfPlannedHolidays("");

              }
              else {
                let alertPlanned = document.getElementById('alertPlanned');
                alertPlanned.textContent = 'Za dużo zaplanowanych dni'

              }
            } else {

              let alertPlanned = document.getElementById('alertPlanned');
              alertPlanned.textContent = 'Zaplanuj 1 lub 2 dni'
            }
          }
        }

      } else {
        let alertPlanned = document.getElementById('alertPlanned');
        alertPlanned.textContent = 'Popraw daty! '
      }

    }

  }

  const resetAlertPlanned2 = () => {
    let alert = document.getElementById('alertPlanned2');
    alert.textContent = ""
  }
  useEffect(() => {
    if (Number(numbersOfDaysPlanned) >= 1) {
      resetAlertPlanned2();
    }



  }, [numbersOfDaysPlanned])


  const closeAddPlannedVacation = () => {
    setAddPlannedDays(false);
    setPlannedDaysName("Zwykły urlop");
    setNumbersOfDaysPlanned("");
    setStartOfPlannedHolidays("");
    setEndOfPlannedHolidays("");
  }


  const resetAlertPlanned = () => {
    let alertPlanned = document.getElementById('alertPlanned');
    alertPlanned.textContent = ""
  }

  const filterDoubleHolidayEdit = () => {

    let select = document.getElementById('editHolidayListPlannedTEST');
    if (plannedListName.length > 0) {

      setEditPlannedDaysName(plannedListName[0]);
      for (let i = 0; i < plannedListName.length; i++) {
        let option = document.createElement("option");
        option.textContent = plannedListName[i];
        select.appendChild(option);
        option.setAttribute('value', plannedListName[i]);

      }
    }
  }

  useEffect(() => {
    if (editPlannedDays == true) {
      filterDoubleHolidayEdit();
    }
  }, [])
  //}, [editPlannedDays])



  const closeEditPlannedVacation = () => {
    setEditPlannedDays(false);
    setEditPlannedDaysName("Zwykły urlop");
    // setNumbersOfDaysPlanned("");
    //setStartOfPlannedHolidays("");
    //setEndOfPlannedHolidays("");
  }

  const resetEditAlertPlanned = () => {
    let editAlertPlanned = document.getElementById('editAlertPlanned');
    editAlertPlanned.textContent = ""
  }

  ////////////////////////////////////////////////////////////////////////////////////
  //Funkcja nizej nie dziala


  const closeAddUserHoliday = (e: React.FormEvent) => {
    e.preventDefault();
    setAddUserHoliday(false);
  }

  const userHolidayOption = () => {

    if (addUserHoliday === true) {
      if (holidayDays2.length > 0) {

        let select = document.getElementById('listUserHolidays');
        for (let i = 0; i < holidayDays2.length; i++) {
          let option = document.createElement("option");
          let day = new Date(holidayDays2[i].Holiday_date)
          if (day.getDay() == 6 && holidayDays2[i].User == 'Together') {

            option.textContent = holidayDays2[i].Holiday_date;
            option.setAttribute('key', holidayDays2[i].Name)
            option.setAttribute('value', holidayDays2[i].Name)
            select.appendChild(option)

          }

        }
      }
    }
  }

  useEffect(() => {

    userHolidayOption();
  }, [addUserHoliday])


  const userEditHolidayOption = () => {

    if (editUserHoliday === true) {
      if (holidayDays2.length > 0) {
        let select = document.getElementById('editListUserHolidays');
        for (let i = 0; i < holidayDays2.length; i++) {
          let option = document.createElement("option");
          let day = new Date(holidayDays2[i].Holiday_date)
          if (day.getDay() == 6 && holidayDays2[i].User == userName) {
            option.textContent = holidayDays2[i].Holiday_date;
            option.setAttribute('key', holidayDays2[i].Name);
            option.setAttribute('value', holidayDays2[i].Name);
            select.appendChild(option);
            userEditHoliday.push({ 'Holiday_date': holidayDays2[i].Holiday_date, 'Date': holidayDays2[i].Date })
          }
        }
      }
      let editListUserHolidays = document.getElementById("editListUserHolidays");
      let editListUserHolidays3 = editListUserHolidays as HTMLSelectElement
      let text = editListUserHolidays3.options[editListUserHolidays3.selectedIndex].text;


      for (let i = 0; i < userEditHoliday.length; i++) {

        if (userEditHoliday[i].Holiday_date == text) {
          setEditUserDate(userEditHoliday[i].Date)
        }
      }
    }

  }


  useEffect(() => {

    userEditHolidayOption();
  }, [editUserHoliday])


  const changeDateHoliday = () => {
    if (editUserHoliday == true) {
      if (holidayDays2.length > 0) {
        for (let i = 0; i < holidayDays2.length; i++) {
          let day = new Date(holidayDays2[i].Holiday_date)
          if (day.getDay() == 6 && holidayDays2[i].User == userName) {

            userEditHoliday.push({ 'Holiday_date': holidayDays2[i].Holiday_date, 'Date': holidayDays2[i].Date })
          }

        }
      }

      let editListUserHolidays = document.getElementById("editListUserHolidays");
      let editListUserHolidays3 = editListUserHolidays as HTMLSelectElement
      let text = editListUserHolidays3.options[editListUserHolidays3.selectedIndex].text;
      console.log(userEditHoliday)
      for (let i = 0; i < userEditHoliday.length; i++) {

        if (userEditHoliday[i].Holiday_date == text) {
          setEditUserDate(userEditHoliday[i].Date)
        }
      }
    }
  }




  const selectYearOfHoliday = () => {
    let select = document.getElementById('yearOfHoliday');
    for (let i = -1; i < 2; i++) {
      let option = document.createElement("option");
      let number = year + i;
      if (number == year) {
        option.setAttribute('selected', 'selected')
      }
      option.textContent = number.toLocaleString();
      option.setAttribute('value', number.toLocaleString());
      //option.setAttribute('key' , Math.random().toLocaleString());
      select.appendChild(option);
    }


  }
  useEffect(() => {
    selectYearOfHoliday()
  }, [])

  const userHoliday = (e: React.FormEvent) => {
    e.preventDefault();


    let listUserHolidays = document.getElementById("listUserHolidays");
    let listUserHolidays2 = listUserHolidays as HTMLInputElement;
    let listUserHolidays3 = listUserHolidays as HTMLSelectElement


    let value = listUserHolidays2.value;
    let text = listUserHolidays3.options[listUserHolidays3.selectedIndex].text;



    let dane = holidayDays2.filter(date => date.Holiday_date === text && date.User === userName)
    if (dane.length > 0) {

      let alert = document.getElementById('alert2');
      alert.textContent = "Święto o takiej nazwie już istnieje"

    } else {


      axios.post(ipAddress + '/addUserHoliday', {
        User: userName,
        Name: value,
        Year: yearListOfHoliday,
        Date: userDate,
        Holiday_Date: text,
        Date_add: date,
        Updated: true,

      })
      setAddUserHoliday(false);
    }


  }

  const userHoliday2 = (e: React.FormEvent) => {
    e.preventDefault();


    let editListUserHolidays = document.getElementById("editListUserHolidays");
    let editListUserHolidays2 = editListUserHolidays as HTMLInputElement;

    let value = editListUserHolidays2.value;

    axios.post(ipAddress + '/editUserHoliday', {
      User: userName,
      Name: value,
      Year: yearListOfHoliday,
      Date: editUserDate,
      Date_update: date,


    })
    setEditUserHoliday(false);



  }


  const editUserHolidays = () => {
    let check: number = 0;
    for (let i = 0; i < holidayDays2.length; i++) {

      let day = new Date(holidayDays2[i].Holiday_date)
      if (day.getDay() == 6 && holidayDays2[i].User == userName) {
        check += 1
      }
    }

    if (check > 0) {
      setEditUserHoliday(true)
      setMenuHolidays(false)
    }
    else {
      let alert = document.getElementById('alertEditHoliday');
      alert.textContent = "Brak dni do edycji"

    }

  }

  //console.log(updateDueDays)

  const filterDoubleHoliday = () => {
    let tab = [];
    for (let i = 0; i < updateDueDays.length; i++) {
      tab.push(updateDueDays[i].Holiday_name)
    }

    let tab2 = [];
    for (let i = 0; i < updateOverdueDays.length; i++) {
      tab2.push(updateOverdueDays[i].Holiday_name)
    }

    let tab3 = tab.concat(tab2);

    let tab4 = tab3.filter((item, index, array) => array.indexOf(item) === index);

    let select = document.getElementById('holidayListPlanned');
    if (tab4.length > 0) {

      setPlannedDaysName(tab4[0]);
      for (let i = 0; i < tab4.length; i++) {
        let option = document.createElement("option");
        option.textContent = tab4[i];
        select.appendChild(option);
        option.setAttribute('value', tab4[i]);

      }
    }
  }

  useEffect(() => {
    if (addPlannedDays == true) {
      filterDoubleHoliday();
    }

  }, [addPlannedDays])


  const countDaysPlanned = () => {
    let start = startOfPlannedHolidays
    let stop = endOfPlannedHolidays



  }
  useState(() => {
    countDaysPlanned()
  })


  const countHolidayDays = () => {
    let startTime = new Date(startOfPlannedHolidays)
    let endTime = new Date(endOfPlannedHolidays)
    //Ilość dni pomiedzy datą początkową, a końcową.
    //let timeDiff = Math.abs(endTime.getTime() - startTime.getTime());
    //let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)

    setNumbersOfDaysPlanned(daysHoliday.toLocaleString())

  }

  useEffect(() => {
    countHolidayDays()
  }, [startOfPlannedHolidays, endOfPlannedHolidays])


  const plannedDaysDownload = () => {
    axios.post(ipAddress + '/plannedDaysDownload', {
      User: userName,
    })
      .then(response => {
        setPlannedDownload(response.data)

      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    plannedDaysDownload()

  }, [plannedDownload, editPlannedDays])

  const usedDaysDownload = () => {
    axios.post(ipAddress + '/UsedDaysDownload', {
      User: userName,
    })
      .then(response => {
        setUsedDownload(response.data)

      })
      .catch(err => {
        console.log(err)
      })
  }



  useEffect(() => {
    usedDaysDownload()

  }, [usedDownload])


  const filtrerDoubleHolidayPlanned = () => {
    let tab = [];
    for (let i = 0; i < plannedDownload.length; i++) {
      tab.push(plannedDownload[i].Holiday_name)
    }

    let tab2 = tab.filter((item, index, array) => array.indexOf(item) === index);
    setPlannedListName(tab2)


  }


  const listPlannedHoliday = (e: React.FormEvent) => {
    let a = e.target as HTMLElement
    let b = a.textContent + " " + "Planned"
    let c = document.getElementById(b);
    c.classList.toggle('notVisible')

  }
  const listUsedHoliday = (e: React.FormEvent) => {
    let a = e.target as HTMLElement
    let b = a.textContent + " " + "Used"
    let c = document.getElementById(b);
    c.classList.toggle('notVisible')

  }


  const test = (Id: number, Holiday_name: string, Start_holiday: string, End_holiday: string, Name_Of_Child: string,
    All_Days: number, Weeks_Days: number, Weekend_Days: number, Holiday_days: number) => {
    if (Holiday_name == 'Urlop ojcowski') {
      setEditNameOfChildPlanned(Name_Of_Child)
    }

    setEditPlannedDaysName(Holiday_name)
    setEditStartOfPlannedHolidays(Start_holiday)
    setEditEndOfPlannedHolidays(End_holiday)
    setEditPlannedDays(true)
    setEditNumbersOfDaysPlanned(String(Weeks_Days))
    setEditId(Id);


  }

  const countHolidayDaysEdit = () => {
    let startTime = new Date(editStartOfPlannedHolidays)
    let endTime = new Date(editEndOfPlannedHolidays)

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)

    setEditNumbersOfDaysPlanned(daysHoliday.toLocaleString())

  }

  useEffect(() => {
    countHolidayDaysEdit()
  }, [editStartOfPlannedHolidays, editEndOfPlannedHolidays])


  const countHolidayDaysEditAlert = () => {
    let startTime = new Date(alertUsedStartOfPlannedHolidays)
    let endTime = new Date(alertUsedEndOfPlannedHolidays)

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // wszystkie dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote w tym okresie
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)

    setEditNumbersOfDaysPlannedAlert(daysHoliday.toLocaleString())
    setAlertUsedAllDays(dates.length)
    setAlertUsedWeekendDays(weekendDays.length)
    setAlertUsedHolidayDays(holidayDays3.length)



  }

  useEffect(() => {
    countHolidayDaysEditAlert()
  }, [alertUsedStartOfPlannedHolidays, alertUsedEndOfPlannedHolidays])


  const countHolidayDaysEditAlert2 = () => {
    console.log('w srodku')

    let startTime = new Date(alertUsedStartOfPlannedHolidays)
    let endTime = new Date(year + '-' + '12-31');


    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // wszystkie dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote w tym okresie
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)
    setCountEndOfTheYear(daysHoliday);


  }
  useEffect(() => {
    if (new Date(alertUsedEndOfPlannedHolidays).getFullYear() > new Date().getFullYear()) {

      countHolidayDaysEditAlert2();
    }

  }, [alertUsedStartOfPlannedHolidays, alertUsedEndOfPlannedHolidays])




  const editPlannedDays2 = (e: React.FormEvent) => {
    e.preventDefault();
    let startTime = new Date(editStartOfPlannedHolidays)
    let endTime = new Date(editEndOfPlannedHolidays)

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else { weeksDays.push(new Date(dateStart)) }

      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)



    if (editPlannedDaysName == "Zwykły urlop") {
      let editAlertPlanned = document.getElementById('editAlertPlanned');
      editAlertPlanned.textContent = '';
      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;
      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editPlannedDaysName) {
          let usedDays = updateDueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == editPlannedDaysName) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }
      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let plannedDaysAll: number = 0;

      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName) {

          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }
        }

      }



      // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
      let different = allDifferentDays - plannedDaysAll;


      if (different >= daysHoliday) {
        axios.post(ipAddress + '/editVacationPlanned', {
          Id: editId,
          WeeksDays: daysHoliday,
          EditData: date,
          HolidayDays: holidayDays.length,
          StartHoliday: editStartOfPlannedHolidays,
          EndHoliday: editEndOfPlannedHolidays,
          AllDays: dates.length,
          WeekendDays: weekendDays.length,
        }
        )
        setEditPlannedDays(false);
        setEditPlannedDaysName("Zwykły urlop");
        setEditNumbersOfDaysPlanned("");
        setEditStartOfPlannedHolidays("");
        setEditEndOfPlannedHolidays("");
      }
      else {
        let editAlertPlanned = document.getElementById('editAlertPlanned');
        editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'


      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////

    if (editPlannedDaysName == "Urlop ojcowski") {
      let editAlertPlanned = document.getElementById('editAlertPlanned');
      editAlertPlanned.textContent = ''
      let nameOfChildPlanned = document.getElementById('editNameOfChildPlanned').innerText
      console.log(nameOfChildPlanned)

      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;


      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editPlannedDaysName && updateDueDays[i].Name_Of_Child == nameOfChildPlanned) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }


      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == editPlannedDaysName && updateOverdueDays[i].Name_Of_Child == nameOfChildPlanned) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }


      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let plannedDaysAll: number = 0;



      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName && plannedDownload[i].Name_Of_Child == nameOfChildPlanned) {
          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }

        }


      }


      let different = allDifferentDays - plannedDaysAll;

      if (daysHoliday == 5 || daysHoliday == 10) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/editVacationPlanned', {
            Id: editId,
            WeeksDays: daysHoliday,
            EditData: date,
            HolidayDays: holidayDays.length,
            StartHoliday: editStartOfPlannedHolidays,
            EndHoliday: editEndOfPlannedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setEditPlannedDays(false);
          setEditPlannedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlanned("");
          setEditStartOfPlannedHolidays("");
          setEditEndOfPlannedHolidays("");

        }
        else {
          let editAlertPlanned = document.getElementById('editAlertPlanned');
          editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let editAlertPlanned = document.getElementById('editAlertPlanned');
        editAlertPlanned.textContent = 'Zaplanuj 5 lub 10 dni'
      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (editPlannedDaysName == "Urlop opiekuńczy") {
      let editAlertPlanned = document.getElementById('editAlertPlanned');
      editAlertPlanned.textContent = ''

      let differentDaysDue: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editPlannedDaysName) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }

      let plannedDaysAll: number = 0;

      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName) {
          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }
        }


      }

      let different = differentDaysDue - plannedDaysAll;



      if (daysHoliday == 1 || daysHoliday == 2) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/editVacationPlanned', {

            Id: editId,
            WeeksDays: daysHoliday,
            EditData: date,
            HolidayDays: holidayDays.length,
            StartHoliday: editStartOfPlannedHolidays,
            EndHoliday: editEndOfPlannedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setEditPlannedDays(false);
          setEditPlannedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlanned("");
          setEditStartOfPlannedHolidays("");
          setEditEndOfPlannedHolidays("");

        }
        else {
          let editAlertPlanned = document.getElementById('editAlertPlanned');
          editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let editAlertPlanned = document.getElementById('editAlertPlanned');
        editAlertPlanned.textContent = 'Zaplanuj 1 lub 2 dni'
      }

    }


  }

  const test2 = (Id: number, Name_Of_Child: string, Holiday_name: string, startOfPlannedHolidays: string, endOfPlannedHolidays: string) => {
    setDeleteId(Id);
    setDeletePlannedDaysName(Holiday_name);
    setDeleteNameOfChildPlanned(Name_Of_Child);
    setDeleteStartOfPlannedHolidays(startOfPlannedHolidays);
    setDeleteEndOfPlannedHolidays(endOfPlannedHolidays);
    setDeletePlannedDays(true);

  }

  const deletePlannedDays2 = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(ipAddress + '/deleteVacationPlanned', {
      Id: deleteId
    })
    setDeletePlannedDays(false)

  }



  const alert2 = () => {

    if (alertUsedDays2 == 0)
      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].End_holiday < date) {
          setAlertUsedDaysName(plannedDownload[i].Holiday_name);
          setAlertUsedStartOfPlannedHolidays(plannedDownload[i].Start_holiday);
          setAlertUsedEndOfPlannedHolidays(plannedDownload[i].End_holiday);
          setAlertUsedNameOfChildPlanned(plannedDownload[i].Name_Of_Child)
          setDeleteIdAlert(plannedDownload[i].Id);
          setIdAlertEdit(plannedDownload[i].Id);
          setAlertUsedWeeksDays(plannedDownload[i].Weeks_Days);
          setAlertUsedHolidayDays(plannedDownload[i].Holiday_days);
          setAlertUsedAllDays(plannedDownload[i].All_Days);
          setAlertUsedWeekendDays(plannedDownload[i].Weekend_Days)

          setAlertUsedDays(true);
        }
      }

  }

  useEffect(() => {
    alert2()

  }, [plannedDownload])

  const updateDataUsedAfterCancelation = () => {


    for (let i = 0; i < plannedDownload.length; i++) {

      if (plannedDownload[i].End_holiday < date) {
        setAlertUsedDaysName(plannedDownload[i].Holiday_name);
        setAlertUsedStartOfPlannedHolidays(plannedDownload[i].Start_holiday);
        setAlertUsedEndOfPlannedHolidays(plannedDownload[i].End_holiday);
        setAlertUsedNameOfChildPlanned(plannedDownload[i].Name_Of_Child)
        setDeleteIdAlert(plannedDownload[i].Id);
        setAlertUsedWeeksDays(plannedDownload[i].Weeks_Days);
        setAlertUsedHolidayDays(plannedDownload[i].Holiday_days);
        setAlertUsedAllDays(plannedDownload[i].All_Days);
        setAlertUsedWeekendDays(plannedDownload[i].Weekend_Days)


      }
    }

  }



  const editUsedPlannedDaysAlert = (e: React.FormEvent) => {
    e.preventDefault();
    setAlertUsedDays2(1)
    setEditUsedPlannedDays(true);

  }


  function notifyMe() {
    if (!("Notification" in window)) {
      // Check if the browser supports notifications
      alert('This browser does not support desktop notification');
      console.log('nie obsługuje')

    } else if (Notification.permission === "granted") {
      // Check whether notification permissions have already been granted;
      // if so, create a notification
      const notification = new Notification("Hi thereeeee!");
      console.log(notification)


    } else if (Notification.permission !== "denied") {
      // We need to ask the user for permission
      Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
          const notification = new Notification("Hi there!");
          console.log(notification)
        }
      });
    }

  }
  useEffect(() => {
    notifyMe();

    return () => {

    }
  }, [])





  const usedPlannedDays = (e: React.FormEvent) => {
    e.preventDefault();

    axios.post(ipAddress + '/addVacationUsed', {
      User: userName,
      HolidayName: alertUsedDaysName,
      WeeksDays: alertUsedWeeksDays,
      Data: date,
      HolidayDays: alertUsedHolidayDays,
      NameOfChild: alertUsedNameOfChildPlanned,
      StartHoliday: alertUsedStartOfPlannedHolidays,
      EndHoliday: alertUsedEndOfPlannedHolidays,
      AllDays: alertUsedAllDays,
      WeekendDays: alertUsedWeekendDays,

    })



    if (alertUsedDaysName == 'Zwykły urlop') {


      //Liczy ile dni zostało urlopu zaległego

      let overdueDays: number = 0;
      let overdueUsedDays: number = 0;

      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name === alertUsedDaysName) {
          overdueDays = updateOverdueDays[i].Days
          overdueUsedDays = updateOverdueDays[i].UsedDays
        }

      }

      let remainingOverdueDays = overdueDays - overdueUsedDays


      //Liczy ile dni zostało urlopu terażniejszego

      let dueDays: number = 0;
      let dueUsedDays: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name === alertUsedDaysName) {
          dueDays = updateDueDays[i].Days
          dueUsedDays = updateDueDays[i].UsedDays


        }
      }
      let remainingDueDays = dueDays - dueUsedDays

      if (alertUsedWeeksDays <= remainingOverdueDays) {

        let remainingOverdueDays2 = alertUsedWeeksDays + overdueUsedDays

        axios.post(ipAddress + '/overdueVacationEdit2', {
          User: userName,
          Holiday_name: alertUsedDaysName,
          UsedDays: remainingOverdueDays2,
          Data_Update: date,


        })

      } else {

        if (remainingOverdueDays !== 0) {
          axios.post(ipAddress + '/overdueVacationEdit2', {
            User: userName,
            Holiday_name: alertUsedDaysName,
            UsedDays: overdueDays,
            Data_Update: date,


          })


        }

        let diffDays3 = alertUsedWeeksDays - remainingOverdueDays

        axios.post(ipAddress + '/dueVacationEdit2', {
          User: userName,
          Holiday_name: alertUsedDaysName,
          UsedDays: diffDays3 + dueUsedDays,
          Data_Update: date,


        })

      }

    }

    if (alertUsedDaysName == 'Urlop ojcowski') {

      let overdueDays: number = 0;
      let overdueUsedDays: number = 0;

      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Name_Of_Child === alertUsedNameOfChildPlanned) {
          overdueDays = updateOverdueDays[i].Days
          overdueUsedDays = updateOverdueDays[i].UsedDays
        }

      }


      let dueDays: number = 0;
      let dueUsedDays: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Name_Of_Child === alertUsedNameOfChildPlanned) {
          dueDays = updateDueDays[i].Days
          dueUsedDays = updateDueDays[i].UsedDays

        }
      }



      if (overdueDays > 0) {
        axios.post(ipAddress + '/overdueVacationEdit3', {
          User: userName,
          NameOfChild: alertUsedNameOfChildPlanned,
          UsedDays: alertUsedWeeksDays + overdueUsedDays,
          Data_Update: date,


        })


      } else {

        axios.post(ipAddress + '/dueVacationEdit3', {
          User: userName,
          NameOfChild: alertUsedNameOfChildPlanned,
          UsedDays: alertUsedWeeksDays + dueUsedDays,
          Data_Update: date,


        })
      }




    }

    if (alertUsedDaysName == 'Urlop opiekuńczy') {
      let dueDays: number = 0;
      let dueUsedDays: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name === alertUsedDaysName) {
          dueDays = updateDueDays[i].Days
          dueUsedDays = updateDueDays[i].UsedDays


        }
      }
      let remainingDueDays = dueDays - dueUsedDays

      axios.post(ipAddress + '/dueVacationEdit2', {
        User: userName,
        Holiday_name: alertUsedDaysName,
        UsedDays: alertUsedWeeksDays + dueUsedDays,
        Data_Update: date,


      })


    }


    axios.post(ipAddress + '/deleteVacationPlanned', {
      Id: deleteIdAlert
    })
    setAlertUsedDays(false)
    setAlertUsedDays2(1)
    setEditUsedPlannedDays(false)

  }



  const editUsedPlannedDays2 = () => {


    if (alertUsedDaysName == "Zwykły urlop") {
      let yearOfStart = new Date(alertUsedStartOfPlannedHolidays)
      let yearOfCompletion = new Date(alertUsedEndOfPlannedHolidays)
      let timeDiff = yearOfCompletion.getTime() - new Date().getTime();
      let diffDays = timeDiff / (1000 * 3600 * 24);


      if (yearOfCompletion.getFullYear() > new Date().getFullYear()) {


        if (yearOfStart.getFullYear() > new Date().getFullYear()) {

          axios.post(ipAddress + '/editVacationPlanned', {
            Id: idAlertEdit,
            WeeksDays: editNumbersOfDaysPlannedAlert,
            EditData: date,
            HolidayDays: alertUsedHolidayDays,
            StartHoliday: alertUsedStartOfPlannedHolidays,
            EndHoliday: alertUsedEndOfPlannedHolidays,
            AllDays: alertUsedAllDays,
            WeekendDays: alertUsedWeekendDays,
          })
          setEditUsedPlannedDays(false);
          setAlertUsedDays(false);
          setAlertUsedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlannedAlert("");
          setAlertUsedStartOfPlannedHolidays("");
          setAlertUsedEndOfPlannedHolidays("");
        } else {
          //liczenie dni w  starym roku.


          let differentDaysOverdue: number = 0;
          let differentDaysDue: number = 0;


          for (let i = 0; i < updateDueDays.length; i++) {
            if (updateDueDays[i].Holiday_name == alertUsedDaysName) {
              let usedDays = updateDueDays[i].UsedDays
              if (usedDays == undefined) {
                usedDays = 0
              }
              let days = updateDueDays[i].Days
              differentDaysDue = days - usedDays

            }
          }

          for (let i = 0; i < updateOverdueDays.length; i++) {
            if (updateOverdueDays[i].Holiday_name == alertUsedDaysName) {
              let usedDays = updateOverdueDays[i].UsedDays
              if (usedDays == undefined) {
                usedDays = 0
              }
              let days = updateOverdueDays[i].Days
              differentDaysOverdue = days - usedDays

            }
          }
          let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

          if (allDifferentDays >= countEndOfTheYear) {
            axios.post(ipAddress + '/editVacationPlanned', {
              Id: idAlertEdit,
              WeeksDays: editNumbersOfDaysPlannedAlert,
              EditData: date,
              HolidayDays: alertUsedHolidayDays,
              StartHoliday: alertUsedStartOfPlannedHolidays,
              EndHoliday: alertUsedEndOfPlannedHolidays,
              AllDays: alertUsedAllDays,
              WeekendDays: alertUsedWeekendDays,
            }
            )
            setEditUsedPlannedDays(false);
            setAlertUsedDays(false);
            setAlertUsedDaysName("Zwykły urlop");
            setEditNumbersOfDaysPlannedAlert("");
            setAlertUsedStartOfPlannedHolidays("");
            setAlertUsedEndOfPlannedHolidays("");
          }
          else {
            let editAlertPlanned = document.getElementById('editUsedAlertPlanned2');
            editAlertPlanned.textContent = 'Za dużo zaplanowanych dni na ten rok'


          }


        }




      } else {
        let editAlertPlanned = document.getElementById('editUsedAlertPlanned');
        editAlertPlanned.textContent = '';
        let editAlertPlanned2 = document.getElementById('editUsedAlertPlanned2');
        editAlertPlanned2.textContent = '';

        let differentDaysOverdue: number = 0;
        let differentDaysDue: number = 0;


        for (let i = 0; i < updateDueDays.length; i++) {
          if (updateDueDays[i].Holiday_name == alertUsedDaysName) {
            let usedDays = updateDueDays[i].UsedDays
            if (usedDays == undefined) {
              usedDays = 0
            }
            let days = updateDueDays[i].Days
            differentDaysDue = days - usedDays

          }
        }

        for (let i = 0; i < updateOverdueDays.length; i++) {
          if (updateOverdueDays[i].Holiday_name == alertUsedDaysName) {
            let usedDays = updateOverdueDays[i].UsedDays
            if (usedDays == undefined) {
              usedDays = 0
            }
            let days = updateOverdueDays[i].Days
            differentDaysOverdue = days - usedDays

          }
        }
        let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

        let plannedDaysAll: number = 0;

        for (let i = 0; i < plannedDownload.length; i++) {

          if (plannedDownload[i].Holiday_name == alertUsedDaysName) {

            if (plannedDownload[i].Id !== editId) {
              plannedDaysAll += plannedDownload[i].Weeks_Days
            }
          }

        }



        // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
        //let different = allDifferentDays - plannedDaysAll;

        if (allDifferentDays >= Number(editNumbersOfDaysPlannedAlert)) {
          axios.post(ipAddress + '/editVacationPlanned', {
            Id: idAlertEdit,
            WeeksDays: editNumbersOfDaysPlannedAlert,
            EditData: date,
            HolidayDays: alertUsedHolidayDays,
            StartHoliday: alertUsedStartOfPlannedHolidays,
            EndHoliday: alertUsedEndOfPlannedHolidays,
            AllDays: alertUsedAllDays,
            WeekendDays: alertUsedWeekendDays,
          }
          )
          setEditUsedPlannedDays(false);
          setAlertUsedDays(false);
          setAlertUsedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlannedAlert("");
          setAlertUsedStartOfPlannedHolidays("");
          setAlertUsedEndOfPlannedHolidays("");
        }
        else {
          let editAlertPlanned = document.getElementById('editUsedAlertPlanned2');
          editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'


        }

      }






    }

    //////////////////////////////////////////////////////////////////////////////////////////////

    if (alertUsedDaysName == "Urlop ojcowski") {
      let editAlertPlanned = document.getElementById('editUsedAlertPlanned2');
      editAlertPlanned.textContent = ''
      //let nameOfChildPlanned = document.getElementById('editNameOfChildPlanned').innerText



      axios.post(ipAddress + '/editVacationPlanned', {
        Id: idAlertEdit,
        WeeksDays: editNumbersOfDaysPlannedAlert,
        EditData: date,
        HolidayDays: alertUsedHolidayDays,
        StartHoliday: alertUsedStartOfPlannedHolidays,
        EndHoliday: alertUsedEndOfPlannedHolidays,
        AllDays: alertUsedAllDays,
        WeekendDays: alertUsedWeekendDays,
      })
      setEditUsedPlannedDays(false);
      setAlertUsedDays(false);
      setAlertUsedDaysName("Zwykły urlop");
      setEditNumbersOfDaysPlannedAlert("");
      setAlertUsedStartOfPlannedHolidays("");
      setAlertUsedEndOfPlannedHolidays("");






    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (alertUsedDaysName == "Urlop opiekuńczy") {
      let editAlertPlanned = document.getElementById('editUsedAlertPlanned2');
      editAlertPlanned.textContent = '';


      let differentDaysDue: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == alertUsedDaysName) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }

      let plannedDaysAll: number = 0;

      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName) {
          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }
        }


      }
      // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
      //let different = differentDaysDue - plannedDaysAll;





      if (Number(editNumbersOfDaysPlannedAlert) == 1 || Number(editNumbersOfDaysPlannedAlert) == 2) {

        if (differentDaysDue >= Number(editNumbersOfDaysPlannedAlert)) {
          axios.post(ipAddress + '/editVacationPlanned', {
            Id: idAlertEdit,
            WeeksDays: editNumbersOfDaysPlannedAlert,
            EditData: date,
            HolidayDays: alertUsedHolidayDays,
            StartHoliday: alertUsedStartOfPlannedHolidays,
            EndHoliday: alertUsedEndOfPlannedHolidays,
            AllDays: alertUsedAllDays,
            WeekendDays: alertUsedWeekendDays,

          }
          )
          setEditUsedPlannedDays(false);
          setAlertUsedDays(false);
          setAlertUsedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlannedAlert("");
          setAlertUsedStartOfPlannedHolidays("");
          setAlertUsedEndOfPlannedHolidays("");


        }
        else {
          let editAlertPlanned = document.getElementById('editUsedAlertPlanned2');
          editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'


        }
      } else {

        let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
        if (differentDaysDue > 1) {
          editUsedAlertPlanned.textContent = 'Zaplanuj maksymalnie ' + differentDaysDue + ' dni'
        } else {
          editUsedAlertPlanned.textContent = 'Zaplanuj maksymalnie ' + differentDaysDue + ' dzień'
        }

      }

    }


  }
  const editUsedAlertPlanned2 = () => {
    let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
    editUsedAlertPlanned.textContent = ""
    let editUsedAlertPlanned2 = document.getElementById('editUsedAlertPlanned2');
    editUsedAlertPlanned2.textContent = ""
  }

  useEffect(() => {
    if (editUsedPlannedDays == true) {
      if (Number(editNumbersOfDaysPlannedAlert) >= 1) {
        editUsedAlertPlanned2();
      }
    }

  }, [editNumbersOfDaysPlannedAlert, alertUsedStartOfPlannedHolidays, alertUsedEndOfPlannedHolidays])


  const usedPlannedDaysEdit = (e: React.FormEvent) => {
    e.preventDefault();

    if (Number(editNumbersOfDaysPlannedAlert) > 0) {


      if (alertUsedDaysName == 'Zwykły urlop') {
        let yearOfCompletion = new Date(alertUsedEndOfPlannedHolidays)
        let timeDiff = yearOfCompletion.getTime() - new Date().getTime();
        let diffDays = timeDiff / (1000 * 3600 * 24);


        console.log(diffDays)
        if (diffDays > -1) {

          editUsedPlannedDays2();
        } else {



          //Liczy ile dni zostało urlopu zaległego

          let overdueDays: number = 0;
          let overdueUsedDays: number = 0;

          for (let i = 0; i < updateOverdueDays.length; i++) {
            if (updateOverdueDays[i].Holiday_name === alertUsedDaysName) {
              overdueDays = updateOverdueDays[i].Days
              overdueUsedDays = updateOverdueDays[i].UsedDays
            }

          }

          let remainingOverdueDays = overdueDays - overdueUsedDays


          //Liczy ile dni zostało urlopu terażniejszego

          let dueDays: number = 0;
          let dueUsedDays: number = 0;

          for (let i = 0; i < updateDueDays.length; i++) {
            if (updateDueDays[i].Holiday_name === alertUsedDaysName) {
              dueDays = updateDueDays[i].Days
              dueUsedDays = updateDueDays[i].UsedDays


            }
          }
          let remainingDueDays = dueDays - dueUsedDays


          if (Number(editNumbersOfDaysPlannedAlert) <= remainingOverdueDays) {

            let remainingOverdueDays2 = Number(editNumbersOfDaysPlannedAlert) + overdueUsedDays

            axios.post(ipAddress + '/overdueVacationEdit2', {
              User: userName,
              Holiday_name: alertUsedDaysName,
              UsedDays: remainingOverdueDays2,
              Data_Update: date,


            })


          } else {

            if (remainingOverdueDays !== 0) {
              axios.post(ipAddress + '/overdueVacationEdit2', {
                User: userName,
                Holiday_name: alertUsedDaysName,
                UsedDays: overdueDays,
                Data_Update: date,


              })


            }


            let diffDays3 = Number(editNumbersOfDaysPlannedAlert) - remainingOverdueDays

            console.log(dueUsedDays)
            console.log(diffDays3)

            axios.post(ipAddress +  '/dueVacationEdit2', {
              User: userName,
              Holiday_name: alertUsedDaysName,
              UsedDays: diffDays3 + dueUsedDays,
              Data_Update: date,


            })




          }
          axios.post( ipAddress + '/addVacationUsed', {
            User: userName,
            HolidayName: alertUsedDaysName,
            WeeksDays: editNumbersOfDaysPlannedAlert,
            Data: date,
            HolidayDays: alertUsedHolidayDays,
            NameOfChild: alertUsedNameOfChildPlanned,
            StartHoliday: alertUsedStartOfPlannedHolidays,
            EndHoliday: alertUsedEndOfPlannedHolidays,
            AllDays: alertUsedAllDays,
            WeekendDays: alertUsedWeekendDays,

          })

          axios.post(ipAddress + '/deleteVacationPlanned', {
            Id: deleteIdAlert
          })
          setAlertUsedDays(false)
          setAlertUsedDays2(1)
          setEditUsedPlannedDays(false)
        }
      }

      ///////////////////////////////////////////////////



      if (alertUsedDaysName == 'Urlop ojcowski') {

        if (Number(editNumbersOfDaysPlannedAlert) == 5 || Number(editNumbersOfDaysPlannedAlert) == 10) {

          let overdueDays: number = 0;
          let overdueUsedDays: number = 0;

          for (let i = 0; i < updateOverdueDays.length; i++) {

            if (updateOverdueDays[i].Name_Of_Child === alertUsedNameOfChildPlanned) {
              overdueDays = updateOverdueDays[i].Days
              overdueUsedDays = updateOverdueDays[i].UsedDays
            }

          }

          let remainingOverdueDays = overdueDays - overdueUsedDays

          let dueDays: number = 0;
          let dueUsedDays: number = 0;

          for (let i = 0; i < updateDueDays.length; i++) {
            if (updateDueDays[i].Name_Of_Child === alertUsedNameOfChildPlanned) {
              dueDays = updateDueDays[i].Days
              dueUsedDays = updateDueDays[i].UsedDays

            }
          }

          let remainingDueDays = dueDays - dueUsedDays


          const countTime = () => {
            let yearOfCompletion = new Date(alertUsedEndOfPlannedHolidays)
            let timeDiff = yearOfCompletion.getTime() - new Date().getTime();
            let diffDays = timeDiff / (1000 * 3600 * 24);


            let dateOfBirth: Date;
            if (diffDays > -1) {
              for (let i = 0; i < updateOverdueDays.length; i++) {
                if (updateOverdueDays[i].Name_Of_Child === alertUsedNameOfChildPlanned) {
                  dateOfBirth = updateOverdueDays[i].Date_Of_Birth
                }

              }
              for (let i = 0; i < updateDueDays.length; i++) {
                if (updateDueDays[i].Name_Of_Child === alertUsedNameOfChildPlanned) {
                  dateOfBirth = updateDueDays[i].Date_Of_Birth
                }
              }

              let timeDiff2 = yearOfCompletion.getTime() - new Date(dateOfBirth).getTime();
              let diffDay2 = timeDiff2 / (1000 * 3600 * 24);


              if (diffDay2 > 365) {
                let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
                editUsedAlertPlanned.textContent = "Urlop nie może być wykorzystany w tym okresie"
              } else {
                editUsedPlannedDays2();

              }




            } else {
              if (overdueDays > 0) {
                axios.post(ipAddress + '/overdueVacationEdit3', {
                  User: userName,
                  NameOfChild: alertUsedNameOfChildPlanned,
                  UsedDays: Number(editNumbersOfDaysPlannedAlert) + overdueUsedDays,
                  Data_Update: date,


                })
                axios.post(ipAddress + '/deleteVacationPlanned', {
                  Id: deleteIdAlert
                })
                setAlertUsedDays(false)
                setAlertUsedDays2(1)
                setEditUsedPlannedDays(false)



              } else {



                axios.post(ipAddress + '/dueVacationEdit3', {
                  User: userName,
                  NameOfChild: alertUsedNameOfChildPlanned,
                  UsedDays: Number(editNumbersOfDaysPlannedAlert) + dueUsedDays,
                  Data_Update: date,


                })

                axios.post(ipAddress + '/deleteVacationPlanned', {
                  Id: deleteIdAlert
                })
                setAlertUsedDays(false)
                setAlertUsedDays2(1)
                setEditUsedPlannedDays(false)


              }

            }

          }


          if (overdueDays > 0) {
            if (remainingOverdueDays >= Number(editNumbersOfDaysPlannedAlert)) {
              countTime();

            } else {
              let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');

              editUsedAlertPlanned.textContent = 'Dodaj maksymalnie ' + remainingOverdueDays + ' dni'

            }

          } else {
            if (remainingDueDays >= Number(editNumbersOfDaysPlannedAlert)) {
              countTime();
            } else {
              let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');

              editUsedAlertPlanned.textContent = 'Dodaj maksymalnie ' + remainingDueDays + ' dni'

            }

          }


        }
        else {

          let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
          editUsedAlertPlanned.textContent = 'Zaplanuj 5 lub 10 dni'

        }
      }

      //////////////////////////////////////////////////////////////////////////////

      if (alertUsedDaysName == 'Urlop opiekuńczy') {

        let yearOfCompletion = new Date(alertUsedEndOfPlannedHolidays)
        if (yearOfCompletion.getFullYear() > new Date().getFullYear()) {
          console.log('przyszły rok')
          let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
          editUsedAlertPlanned.textContent = 'Ten urlop nie może być wykorzystany w przyszłym roku'


        } else {

          if (Number(editNumbersOfDaysPlannedAlert) == 1 || Number(editNumbersOfDaysPlannedAlert) == 2) {


            let dueDays: number = 0;
            let dueUsedDays: number = 0;

            for (let i = 0; i < updateDueDays.length; i++) {
              if (updateDueDays[i].Holiday_name === alertUsedDaysName) {
                dueDays = updateDueDays[i].Days
                dueUsedDays = updateDueDays[i].UsedDays


              }
            }
            let remainingDueDays = dueDays - dueUsedDays

            if (remainingDueDays >= Number(editNumbersOfDaysPlannedAlert)) {

              let yearOfCompletion = new Date(alertUsedEndOfPlannedHolidays)
              let timeDiff = yearOfCompletion.getTime() - new Date().getTime();
              let diffDays = timeDiff / (1000 * 3600 * 24);
              if (diffDays > -1) {
                editUsedPlannedDays2();

              } else {

                axios.post(ipAddress + '/dueVacationEdit2', {
                  User: userName,
                  Holiday_name: alertUsedDaysName,
                  UsedDays: Number(editNumbersOfDaysPlannedAlert) + dueUsedDays,
                  Data_Update: date,


                })
                axios.post(ipAddress + '/deleteVacationPlanned', {
                  Id: deleteIdAlert
                })
                setAlertUsedDays(false)
                setAlertUsedDays2(1)
                setEditUsedPlannedDays(false)
              }
            } else {
              let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
              if (remainingDueDays > 1) {
                editUsedAlertPlanned.textContent = 'Zaplanuj maksymalnie ' + remainingDueDays + ' dni'
              } else {
                editUsedAlertPlanned.textContent = 'Zaplanuj maksymalnie ' + remainingDueDays + ' dzień'
              }


            }





          }
          else {
            let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
            editUsedAlertPlanned.textContent = 'Zaplanuj 1 lub 2 dni'
          }
        }
      }



    } else {
      let editUsedAlertPlanned2 = document.getElementById('editUsedAlertPlanned');
      editUsedAlertPlanned2.textContent = 'Popraw daty ! ';

    }


  }




  const resetAlertEdit2 = () => {
    let editUsedAlertPlanned = document.getElementById('editUsedAlertPlanned');
    editUsedAlertPlanned.textContent = '';
    let editUsedAlertPlanned2 = document.getElementById('editUsedAlertPlanned2');
    editUsedAlertPlanned2.textContent = '';

  }
  useEffect(() => {
    if (editUsedPlannedDays == true) {
      if (Number(editNumbersOfDaysPlannedAlert) >= 1) {
        resetAlertEdit2();
      }
    }


  }, [editNumbersOfDaysPlannedAlert])


  const deleteUsedPlannedDays = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(ipAddress + '/deleteVacationPlanned', {
      Id: deleteIdAlert
    })
    setAlertUsedDays(false)
    setAlertUsedDays2(1)
  }

  const filtrerDoubleHolidayUsed = () => {
    let tab = [];
    for (let i = 0; i < usedDownload.length; i++) {
      tab.push(usedDownload[i].Holiday_name)
    }

    let tab2 = tab.filter((item, index, array) => array.indexOf(item) === index);
    setUsedListName(tab2)


  }


  const usedPlannedDaysAlert = (e: React.FormEvent) => {
    e.preventDefault();
    let startTime = new Date(editStartOfPlannedHolidays)
    let endTime = new Date(editEndOfPlannedHolidays)

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else { weeksDays.push(new Date(dateStart)) }

      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)



    if (editPlannedDaysName == "Zwykły urlop") {
      let editAlertPlanned = document.getElementById('editAlertPlanned');
      editAlertPlanned.textContent = '';
      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;
      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editPlannedDaysName) {
          let usedDays = updateDueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == editPlannedDaysName) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }
      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let plannedDaysAll: number = 0;

      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName) {

          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }
        }

      }



      // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
      let different = allDifferentDays - plannedDaysAll;


      if (different >= daysHoliday) {
        axios.post(ipAddress + '/editVacationPlanned', {
          Id: editId,
          WeeksDays: daysHoliday,
          EditData: date,
          HolidayDays: holidayDays.length,
          StartHoliday: editStartOfPlannedHolidays,
          EndHoliday: editEndOfPlannedHolidays,
          AllDays: dates.length,
          WeekendDays: weekendDays.length,
        }
        )
        setEditPlannedDays(false);
        setEditPlannedDaysName("Zwykły urlop");
        setEditNumbersOfDaysPlanned("");
        setEditStartOfPlannedHolidays("");
        setEditEndOfPlannedHolidays("");
      }
      else {
        let editAlertPlanned = document.getElementById('editAlertPlanned');
        editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'


      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////

    if (editPlannedDaysName == "Urlop ojcowski") {
      let editAlertPlanned = document.getElementById('editAlertPlanned');
      editAlertPlanned.textContent = ''
      let nameOfChildPlanned = document.getElementById('editNameOfChildPlanned').innerText
      console.log(nameOfChildPlanned)

      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;


      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editPlannedDaysName && updateDueDays[i].Name_Of_Child == nameOfChildPlanned) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }


      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == editPlannedDaysName && updateOverdueDays[i].Name_Of_Child == nameOfChildPlanned) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }


      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let plannedDaysAll: number = 0;



      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName && plannedDownload[i].Name_Of_Child == nameOfChildPlanned) {
          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }

        }


      }


      let different = allDifferentDays - plannedDaysAll;

      if (daysHoliday == 5 || daysHoliday == 10) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/editVacationPlanned', {
            Id: editId,
            WeeksDays: daysHoliday,
            EditData: date,
            HolidayDays: holidayDays.length,
            StartHoliday: editStartOfPlannedHolidays,
            EndHoliday: editEndOfPlannedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setEditPlannedDays(false);
          setEditPlannedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlanned("");
          setEditStartOfPlannedHolidays("");
          setEditEndOfPlannedHolidays("");

        }
        else {
          let editAlertPlanned = document.getElementById('editAlertPlanned');
          editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let editAlertPlanned = document.getElementById('editAlertPlanned');
        editAlertPlanned.textContent = 'Zaplanuj 5 lub 10 dni'
      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (editPlannedDaysName == "Urlop opiekuńczy") {
      let editAlertPlanned = document.getElementById('editAlertPlanned');
      editAlertPlanned.textContent = ''

      let differentDaysDue: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editPlannedDaysName) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }

      let plannedDaysAll: number = 0;

      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == editPlannedDaysName) {
          if (plannedDownload[i].Id !== editId) {
            plannedDaysAll += plannedDownload[i].Weeks_Days
          }
        }


      }

      let different = differentDaysDue - plannedDaysAll;

      console.log(differentDaysDue)
      console.log(plannedDaysAll)

      console.log(different)
      console.log(daysHoliday)





      if (daysHoliday == 1 || daysHoliday == 2) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/editVacationPlanned', {

            Id: editId,
            WeeksDays: daysHoliday,
            EditData: date,
            HolidayDays: holidayDays.length,
            StartHoliday: editStartOfPlannedHolidays,
            EndHoliday: editEndOfPlannedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setEditPlannedDays(false);
          setEditPlannedDaysName("Zwykły urlop");
          setEditNumbersOfDaysPlanned("");
          setEditStartOfPlannedHolidays("");
          setEditEndOfPlannedHolidays("");

        }
        else {
          let editAlertPlanned = document.getElementById('editAlertPlanned');
          editAlertPlanned.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let editAlertPlanned = document.getElementById('editAlertPlanned');
        editAlertPlanned.textContent = 'Zaplanuj 1 lub 2 dni'
      }

    }


  }


  const test3 = (Id: number, Holiday_name: string, Start_holiday: string, End_holiday: string, Name_Of_Child: string,
    All_Days: number, Weeks_Days: number, Weekend_Days: number, Holiday_days: number) => {
    if (Holiday_name == 'Urlop ojcowski') {
      setEditNameOfChildUsed(Name_Of_Child)
    }

    setEditUsedDaysName(Holiday_name)
    setEditStartOfUsedHolidays(Start_holiday)
    setEditEndOfUsedHolidays(End_holiday)
    setEditUsedDays(true)
    setEditNumbersOfDaysUsed(String(Weeks_Days))
    setEditIdUsed(Id);


  }

  const test4 = (Id: number, Name_Of_Child: string, Holiday_name: string, startOfPlannedHolidays: string, endOfPlannedHolidays: string) => {
    setDeleteIdUsed(Id);
    setDeleteUsedDaysName(Holiday_name);
    setDeleteNameOfChildUsed(Name_Of_Child);
    setDeleteStartOfUsedHolidays(startOfPlannedHolidays);
    setDeleteEndOfUsedHolidays(endOfPlannedHolidays);
    setDeleteUsedDays(true);

  }

  const usedDays2 = (e: React.FormEvent) => {
    e.preventDefault();

    let startTime = new Date(startOfUsedHolidays)
    let endTime = new Date(endOfUsedHolidays)
    //Ilość dni pomiedzy datą początkową, a końcową.
    //let timeDiff = Math.abs(endTime.getTime() - startTime.getTime());
    //let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }


    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }


    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }


    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)


    if (usedDaysName == "Zwykły urlop") {
      let alertUsed = document.getElementById('alertUsed');
      alertUsed.textContent = '';
      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;
      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == usedDaysName) {
          let usedDays = updateDueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == plannedDaysName) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }
      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let plannedDaysAll: number = 0;

      for (let i = 0; i < plannedDownload.length; i++) {

        if (plannedDownload[i].Holiday_name == plannedDaysName) {

          plannedDaysAll += plannedDownload[i].Weeks_Days
        }


      }


      // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
      let different = allDifferentDays - plannedDaysAll;

      if (different >= daysHoliday) {
        axios.post(ipAddress + '/addVacationUsed', {
          User: userName,
          HolidayName: usedDaysName,
          WeeksDays: daysHoliday,
          Data: date,
          HolidayDays: holidayDays.length + holidayDays3.length,
          NameOfChild: nameOfChildUsed,
          StartHoliday: startOfUsedHolidays,
          EndHoliday: endOfUsedHolidays,
          AllDays: dates.length,
          WeekendDays: weekendDays.length,
        }
        )
        setAddUsedDays(false);
        setUsedDaysName("Zwykły urlop");
        setNumbersOfDaysUsed("");
        setStartOfUsedHolidays("");
        setEndOfUsedHolidays("");
      }
      else {
        let alertUsed = document.getElementById('alertUsed');
        alertUsed.textContent = 'Za dużo zaplanowanych dni. Usuń dni planowaneee'


      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////

    if (usedDaysName == "Urlop ojcowski") {
      let alertUsed = document.getElementById('alertUsed');
      alertUsed.textContent = ''
      let nameOfChildUsed = document.getElementById('nameOfChildUsed') as HTMLSelectElement
      let nameOfChildUsed2 = nameOfChildUsed.options[nameOfChildUsed.selectedIndex].text
      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;


      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == usedDaysName && updateDueDays[i].Name_Of_Child == nameOfChildUsed2) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }


      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == usedDaysName && updateOverdueDays[i].Name_Of_Child == nameOfChildUsed2) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }


      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let usedDaysAll: number = 0;



      for (let i = 0; i < usedDownload.length; i++) {

        if (usedDownload[i].Holiday_name == usedDaysName && usedDownload[i].Name_Of_Child == nameOfChildUsed2) {
          usedDaysAll = plannedDownload[i].Weeks_Days
        }


      }

      let different = allDifferentDays - usedDaysAll;

      if (daysHoliday == 5 || daysHoliday == 10) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/addVacationUsed', {
            User: userName,
            HolidayName: usedDaysName,
            WeeksDays: daysHoliday,
            Data: date,
            HolidayDays: holidayDays.length,
            NameOfChild: nameOfChildUsed2,
            StartHoliday: startOfUsedHolidays,
            EndHoliday: endOfUsedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setAddUsedDays(false);
          setUsedDaysName("Zwykły urlop");
          setNumbersOfDaysUsed("");
          setStartOfUsedHolidays("");
          setEndOfUsedHolidays("");

        }
        else {
          let alertUsed = document.getElementById('alertUsed');
          alertUsed.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let alertUsed = document.getElementById('alertUsed');
        alertUsed.textContent = 'Zaplanuj 5 lub 10 dni'
      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (usedDaysName == "Urlop opiekuńczy") {
      let alertUsed = document.getElementById('alertUsed');
      alertUsed.textContent = ''

      let differentDaysDue: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == usedDaysName) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }
      console.log(differentDaysDue)

      let usedDaysAll: number = 0;

      for (let i = 0; i < usedDownload.length; i++) {

        if (usedDownload[i].Holiday_name == usedDaysName) {
          usedDaysAll = usedDownload[i].Weeks_Days
        }


      }

      let different = differentDaysDue - usedDaysAll;



      if (daysHoliday == 1 || daysHoliday == 2) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/addVacationUsed', {
            User: userName,
            HolidayName: usedDaysName,
            WeeksDays: daysHoliday,
            Data: date,
            HolidayDays: holidayDays.length,
            NameOfChild: '',
            StartHoliday: startOfUsedHolidays,
            EndHoliday: endOfUsedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setAddUsedDays(false);
          setUsedDaysName("Zwykły urlop");
          setNumbersOfDaysUsed("");
          setStartOfUsedHolidays("");
          setEndOfUsedHolidays("");

        }
        else {
          let alertUsed = document.getElementById('alertUsed');
          alertUsed.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let alertUsed = document.getElementById('alertUsed');
        alertUsed.textContent = 'Zaplanuj 1 lub 2 dni'
      }

    }

  }
  const closeAddUsedVacation = () => {
    setAddUsedDays(false);
    setUsedDaysName("Zwykły urlop");
    setNumbersOfDaysUsed("");
    setStartOfUsedHolidays("");
    setEndOfUsedHolidays("");
  }

  const resetAlertUsed = () => {
    let alertUsed = document.getElementById('alertUsed');
    alertUsed.textContent = ""
  }

  const filterDoubleHolidayUsed = () => {
    let tab = [];
    for (let i = 0; i < updateDueDays.length; i++) {
      tab.push(updateDueDays[i].Holiday_name)
    }

    let tab2 = [];
    for (let i = 0; i < updateOverdueDays.length; i++) {
      tab2.push(updateOverdueDays[i].Holiday_name)
    }

    let tab3 = tab.concat(tab2);

    let tab4 = tab3.filter((item, index, array) => array.indexOf(item) === index);

    let select = document.getElementById('holidayListUsed');
    if (tab4.length > 0) {

      setUsedDaysName(tab4[0]);
      for (let i = 0; i < tab4.length; i++) {
        let option = document.createElement("option");
        option.textContent = tab4[i];
        select.appendChild(option);
        option.setAttribute('value', tab4[i]);

      }
    }
  }

  useEffect(() => {
    if (addUsedDays == true) {
      filterDoubleHolidayUsed();
    }

  }, [addUsedDays])


  const countHolidayDaysUsed = () => {
    let startTime = new Date(startOfUsedHolidays)
    let endTime = new Date(endOfUsedHolidays)
    //Ilość dni pomiedzy datą początkową, a końcową.
    //let timeDiff = Math.abs(endTime.getTime() - startTime.getTime());
    //let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)

    setNumbersOfDaysUsed(daysHoliday.toLocaleString())

  }

  useEffect(() => {
    countHolidayDaysUsed()
  }, [startOfUsedHolidays, endOfUsedHolidays])


  const resetEditAlertUsed = () => {
    let editAlertUsed = document.getElementById('editAlertUsed');
    editAlertUsed.textContent = ""
  }


  const editUsedDays2 = (e: React.FormEvent) => {
    e.preventDefault();
    let startTime = new Date(editStartOfUsedHolidays)
    let endTime = new Date(editEndOfUsedHolidays)

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else { weeksDays.push(new Date(dateStart)) }

      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)




    if (editUsedDaysName == "Zwykły urlop") {
      let editAlertUsed = document.getElementById('editAlertUsed');
      editAlertUsed.textContent = '';
      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;
      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editUsedDaysName) {
          let usedDays = updateDueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }
      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == editUsedDaysName) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }
      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let usedDaysAll: number = 0;

      for (let i = 0; i < usedDownload.length; i++) {

        if (usedDownload[i].Holiday_name == editUsedDaysName) {

          if (usedDownload[i].Id !== editId) {
            usedDaysAll += usedDownload[i].Weeks_Days
          }
        }

      }



      // Zsumowane dni tego samego urlopu odejmują się od liczby dni planowanego urlopu
      let different = allDifferentDays - usedDaysAll;


      if (different >= daysHoliday) {
        axios.post(ipAddress + '/editVacationUsed', {
          Id: editIdUsed,
          WeeksDays: daysHoliday,
          EditData: date,
          HolidayDays: holidayDays.length,
          StartHoliday: editStartOfUsedHolidays,
          EndHoliday: editEndOfUsedHolidays,
          AllDays: dates.length,
          WeekendDays: weekendDays.length,
        }
        )
        setEditUsedDays(false);
        setEditUsedDaysName("Zwykły urlop");
        setEditNumbersOfDaysUsed("");
        setEditStartOfUsedHolidays("");
        setEditEndOfUsedHolidays("");
      }
      else {
        let editAlertUsed = document.getElementById('editAlertUsed');
        editAlertUsed.textContent = 'Za dużo zaplanowanych dni'


      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////

    if (editUsedDaysName == "Urlop ojcowski") {
      let editAlertUsed = document.getElementById('editAlertUsed');
      editAlertUsed.textContent = ''
      let nameOfChildUsed = document.getElementById('editNameOfChildUsed').innerText


      let differentDaysOverdue: number = 0;
      let differentDaysDue: number = 0;


      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editUsedDaysName && updateDueDays[i].Name_Of_Child == nameOfChildUsed) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }


      for (let i = 0; i < updateOverdueDays.length; i++) {
        if (updateOverdueDays[i].Holiday_name == editUsedDaysName && updateOverdueDays[i].Name_Of_Child == nameOfChildUsed) {
          let usedDays = updateOverdueDays[i].UsedDays
          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateOverdueDays[i].Days
          differentDaysOverdue = days - usedDays

        }
      }


      let allDifferentDays: number = differentDaysDue + differentDaysOverdue;

      let usedDaysAll: number = 0;



      for (let i = 0; i < usedDownload.length; i++) {

        if (usedDownload[i].Holiday_name == editUsedDaysName && usedDownload[i].Name_Of_Child == nameOfChildUsed) {
          if (usedDownload[i].Id !== editId) {
            usedDaysAll += usedDownload[i].Weeks_Days
          }

        }


      }


      let different = allDifferentDays - usedDaysAll;

      if (daysHoliday == 5 || daysHoliday == 10) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/editVacationUsed', {
            Id: editIdUsed,
            WeeksDays: daysHoliday,
            EditData: date,
            HolidayDays: holidayDays.length,
            StartHoliday: editStartOfUsedHolidays,
            EndHoliday: editEndOfUsedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setEditUsedDays(false);
          setEditUsedDaysName("Zwykły urlop");
          setEditNumbersOfDaysUsed("");
          setEditStartOfUsedHolidays("");
          setEditEndOfUsedHolidays("");

        }
        else {
          let editAlertUsed = document.getElementById('editAlertUsed');
          editAlertUsed.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let editAlertUsed = document.getElementById('editAlertUsed');
        editAlertUsed.textContent = 'Zaplanuj 5 lub 10 dni'
      }

    }

    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    if (editUsedDaysName == "Urlop opiekuńczy") {
      let editAlertUsed = document.getElementById('editAlertUsed');
      editAlertUsed.textContent = ''

      let differentDaysDue: number = 0;

      for (let i = 0; i < updateDueDays.length; i++) {
        if (updateDueDays[i].Holiday_name == editUsedDaysName) {
          let usedDays = updateDueDays[i].UsedDays

          if (usedDays == undefined) {
            usedDays = 0
          }
          let days = updateDueDays[i].Days
          differentDaysDue = days - usedDays

        }
      }

      let usedDaysAll: number = 0;

      for (let i = 0; i < usedDownload.length; i++) {

        if (usedDownload[i].Holiday_name == editUsedDaysName) {
          if (usedDownload[i].Id !== editId) {
            usedDaysAll += usedDownload[i].Weeks_Days
          }
        }


      }

      let different = differentDaysDue - usedDaysAll;

      if (daysHoliday == 1 || daysHoliday == 2) {

        if (different >= daysHoliday) {
          axios.post(ipAddress + '/editVacationUsed', {

            Id: editIdUsed,
            WeeksDays: daysHoliday,
            EditData: date,
            HolidayDays: holidayDays.length,
            StartHoliday: editStartOfUsedHolidays,
            EndHoliday: editEndOfUsedHolidays,
            AllDays: dates.length,
            WeekendDays: weekendDays.length,
          }
          )
          setEditUsedDays(false);
          setEditUsedDaysName("Zwykły urlop");
          setEditNumbersOfDaysUsed("");
          setEditStartOfUsedHolidays("");
          setEditEndOfUsedHolidays("");

        }
        else {
          let editAlertUsed = document.getElementById('editAlertUsed');
          editAlertUsed.textContent = 'Za dużo zaplanowanych dni'

        }
      } else {

        let editAlertUsed = document.getElementById('editAlertUsed');
        editAlertUsed.textContent = 'Zaplanuj 1 lub 2 dni'
      }

    }


  }

  const closeEditUsedVacation = () => {
    setEditUsedDays(false);
    setEditUsedDaysName("Zwykły urlop");

  }

  const deleteUsedDays2 = (e: React.FormEvent) => {
    e.preventDefault();
    axios.post(ipAddress + '/deleteVacationUsed', {
      Id: deleteIdUsed
    })
    setDeleteUsedDays(false)

  }


  const countHolidayDaysEditUsed = () => {
    let startTime = new Date(editStartOfUsedHolidays)
    let endTime = new Date(editEndOfUsedHolidays)

    //Ilość dni pomiedzy datą początkową, a końcową.
    //let timeDiff = Math.abs(endTime.getTime() - startTime.getTime());
    //let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24)) + 1;

    const dateStart = startTime;

    const dates = []; // wszystkie dni pomiedzy data poczatkowa a końcową
    const weekendDays = [];
    const weeksDays = [];
    const togetherDays = [] // dni świąteczne
    const userDays = []; // dni świąteczne oddane za święto przepadające w sobotę
    const holidayDays = []; // ile dni zaplanowanych przepada w dzien wolnego za sobote
    const holidayDays3 = []; // ile dni zaplanowanych przepada w święto

    // holidayDays2 - wszystkie dni swiąteczne togheter + User

    //Sprawdza czy użytkownik ma jakieś dodane dni za święto przepadające w sobote i dodaje je do tabeli.
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == userName) {
        userDays.push(holidayDays2[i].Date)
      }
    }
    //Dodaje same dni świąteczne 
    for (let i = 0; i < holidayDays2.length; i++) {
      if (holidayDays2[i].User == 'Together') {
        togetherDays.push(holidayDays2[i].Holiday_date)
      }
    }


    while (dateStart <= endTime) {
      dates.push(new Date(dateStart));

      if (dateStart.getDay() == 0 || dateStart.getDay() == 6) {
        weekendDays.push(new Date(dateStart))
      } else (weeksDays.push(new Date(dateStart)))
      dateStart.setDate(dateStart.getDate() + 1);
    }

    // Sprawdza czy któryś dzien w tygodniu przepada w dzień oddany za świeto wypadające w sobote
    weeksDays.filter(date => {

      for (let i = 0; i < userDays.length; i++) {
        if (date.toLocaleDateString() == new Date(userDays[i]).toLocaleDateString()) {
          holidayDays.push(new Date(userDays[i]).toLocaleDateString())
        }
      }

    })
    // Sprawdza czy któryś dzien w tygodniu przepada w święto
    weeksDays.filter(date => {

      for (let i = 0; i < togetherDays.length; i++) {
        if (date.toLocaleDateString() == new Date(togetherDays[i]).toLocaleDateString()) {
          holidayDays3.push(new Date(togetherDays[i]).toLocaleDateString())
        }
      }

    })


    // Odejmuje od wszystkich dni , dni przepadające w weekend i oddane za święto w sobotę.
    let daysHoliday = dates.length - (weekendDays.length + holidayDays.length + holidayDays3.length)

    setEditNumbersOfDaysUsed(daysHoliday.toLocaleString())

  }

  useEffect(() => {
    countHolidayDaysEditUsed()
  }, [editStartOfUsedHolidays, editEndOfUsedHolidays])


  const selectYearOfHolidayUsed = () => {
    let select = document.getElementById('listYearUsedHoliday');
    for (let i = -1; i < 2; i++) {
      let option = document.createElement("option");
      let number = year + i;
      if (number == year) {
        option.setAttribute('selected', 'selected')
      }
      option.textContent = number.toLocaleString();
      option.setAttribute('value', number.toLocaleString());
      //option.setAttribute('key' , Math.random().toLocaleString());
      select.appendChild(option);
    }
    setYearListOfHolidayUsed(String(year))



  }
  useEffect(() => {
    selectYearOfHolidayUsed()
  }, [])



  return (
    <div className='holiday'>
      <div className='title'>
        <Link to='..'> <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} /></Link>
        <span id='title'>Holiday</span>
      </div>
      <div className='holidayList2'>
        <Link to='/Holiday'>Urlop</Link>
        <Link to='/Holiday/L4'>L4</Link>
      </div>

      <Outlet />

      <div className='userSelect'>
        <div id='select'>
          <select id='userName' onChange={(e) => setUserName(e.target.value)}>
            <option value="Przemek">Przemek</option>
            <option value="Asia">Asia</option>
          </select>
        </div>
        <div id='date'>
          <p id='date'>{date}</p>
        </div>

      </div>
      <div>
        <p id='head'>Liczba dni urlopowych</p>

      </div>

      <div className='allDays'>
        <div className='overdueAll'>
          <div className='overdueTitle' >
            <p className='text' onClick={() => overdueHoliday()}>Urlop zaległy : {overdue - usedOverdue} / {overdue} dni</p>
            <span className='icon' onClick={() => setMenuOverdueDays(true)} ><AiOutlineAppstoreAdd /></span>
          </div>

          {menuOverdueDays ? (
            <div className='addOption'>
              <p>Urlop zaległy</p>
              <p onClick={() => setAddOverdueDays(true)}><IoMdAddCircle /><span>Dodaj</span></p>
              <p onClick={() => setEditOverdueDays(true)}><AiFillEdit /><span>Edytuj</span></p>
              <p onClick={() => setDeleteOverdueDays(true)}><AiFillDelete /><span>Usuń</span></p>
              <button onClick={() => setMenuOverdueDays(false)}>Cancel</button>
            </div>
          ) : (<div></div>)}



          <div id='overdue' className='overdue notVisible' >
            {updateOverdueDays.map((element) => <p className='overdueOne' key={element.Id}><span>  {element.Holiday_name + ' ' + element.Name_Of_Child + ':' + ' '} {element.Days - element.UsedDays} / {element.Days + ' dni'}</span></p>)}




          </div>

        </div>

        {addOverdueDays ?
          (
            <form className='overdueDays' onSubmit={(e) => { OverdueDays2(e) }}>
              <span className='icon' id='close' onClick={() => closeAddOverdueVacation()} ><AiOutlineClose /></span>
              <p>Dodaj zaległe dni urlopowe</p>
              <div>
                <label htmlFor='nameHoliday' id='nameOverdueHoliday'>Nazwa urlopu :</label>
              </div>
              <select name='listHolidays' id='listOverdueHolidays' onChange={(e) => (setOverdueDays(e.target.value), resetAlertOverdue())}>
                <option value="Zwykły urlop">Zwykły urlop</option>
                <option value="Urlop ojcowski">Urlop ojcowski</option>

              </select>

              {overdueDays == "Urlop ojcowski" ?
                (
                  <div>
                    <p>Ilość dni:</p>
                    <select name='numberOfDaysOverdue' id='numberOfDaysOverdue' onChange={(e) => setNumberOverdueDays2(e.target.value)}>
                      <option value='10'>10 dni</option>
                      <option value='5'>5 dni</option>
                    </select>
                    <label htmlFor='nameOfChildOverdue' id='nameOfChildOverdue'>Imię dziecka:</label>
                    <input type="text" onChange={(e) => setNameOfChildOverdue(e.target.value)} />
                    <label htmlFor='dateOfBirthOverdue' id='dateOfBirthOverdue'>Data urodzenia dziecka:</label>
                    <input type="date" onChange={(e) => setDateOfBirthOverdue(e.target.value)} />
                  </div>)
                :
                (<div></div>)
              }
              {overdueDays == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <input type="number" placeholder='Ilość dni' onChange={(e) => setNumberOverdueDays(e.target.value)} required />
                    </div>

                  </div>)
                :
                (<div></div>)
              }



              <button type='submit'>OK</button>
              <div id='alertOverdue'></div>
            </form>
          )
          :
          (<div></div>)

        }
        {editOverdueDays ?
          (
            <form className='editOverdueDays' onSubmit={(e) => { overdueDaysEdit(e) }}>
              <span className='icon' id='closeEdit' onClick={() => setEditOverdueDays(false)} ><AiOutlineClose /></span>
              <p>Edytuj zaległe dni urlopowe</p>

              {updateOverdueDays.length > 0 ?
                (<div>
                  <div>
                    <label htmlFor='nameHoliday' id='editNameOverdueHoliday'>Nazwa urlopu :</label>
                  </div>
                  <select name='editListHolidays' id='editListOverdueHolidays' onChange={(e) => editOverdueHoliday2(e)}>

                  </select>

                  {editNameOverdueDays == "Zwykły urlop" ?
                    (
                      <div>
                        <div>
                          <input type="number" value={editNumberOverdueDays} onChange={(e) => setEditNumberOverdueDays(e.target.value)} />
                        </div>

                      </div>)
                    :
                    (<div></div>)
                  }


                  {editNameOverdueDays == "Urlop ojcowski" ?
                    (<div>
                      <select name="nameOfChild" id='editNameOfChildOverdue2' onChange={(e) => editOverdueHoliday3(e)}>
                        {updateOverdueDays.map((element) => (

                          element.Holiday_name == 'Urlop ojcowski' &&
                          <option value={element.Id} key={element.Id}> {element.Name_Of_Child}</option>
                        )
                        )
                        }
                      </select>



                      <label htmlFor='editNameOfChildOverdue' id='editNameOfChildOverdue'>Imię dziecka:</label>
                      <input type="text" value={editNameOfChildOverdue} onChange={(e) => setEditNameOfChildOverdue(e.target.value)} />
                      <label htmlFor='editNameDateOfBirthOverdue' id='editNameDateOfBirthOverdue'>Data urodzenia dziecka:</label>
                      <input type="date" value={editDateOfBirthOverdue} onChange={(e) => setEditDateOfBirthOverdue(e.target.value)} />
                      <p>Ilość dni:</p>
                      <select name='editNumberOfDaysOverdue' id='editNumberOfDaysOverdue' value={editNumberOverdueDays2} onChange={(e) => setEditNumberOverdueDays2(e.target.value)}>
                        <option value='10'>10 dni</option>
                        <option value='5'>5 dni</option>
                      </select>
                    </div>)
                    :
                    (<div></div>)
                  }


                  <button type='submit'>Edytuj</button>

                </div>)
                :
                (
                  <div className='noneOverdueDays'>Brak zaległych dni do edytowania</div>
                )
              }

            </form>
          )
          :
          (<div></div>)

        }
        {deleteOverdueDays ?
          (
            <form className='deleteOverdueDays' onSubmit={(e) => { overdueDaysDelete(e) }}>
              <span className='icon' id='closeDelete' onClick={() => setDeleteOverdueDays(false)} ><AiOutlineClose /></span>
              <p>Usuń zaległe dni urlopowe</p>
              {updateOverdueDays.length > 0 ?
                (
                  <div> <div>
                    <label htmlFor='nameHoliday' id='deleteNameOverdueHoliday'>Nazwa urlopu :</label>
                  </div>
                    <select name='editListHolidays' id='deleteListOverdueHolidays' onChange={(e) => deleteOverdueHoliday2(e)}>

                    </select>
                    {deleteNameOverdueDays == "Urlop ojcowski" ?
                      (<div>
                        <select name="nameOfChild" id='deleteNameOfChildOverdue2' onChange={(e) => deleteOverdueHoliday3(e)}>
                          {updateOverdueDays.map((element) => (

                            element.Holiday_name == 'Urlop ojcowski' &&
                            <option value={element.Id} key={element.Id}> {element.Name_Of_Child}</option>
                          )
                          )
                          }
                        </select>

                      </div>)
                      :
                      (<div></div>)
                    }

                    <button type='submit'>Usuń</button></div>
                ) : (
                  <div className='noneOverdueDays'>Brak zaległych dni do usunięcia</div>
                )

              }



            </form>
          )
          :
          (<div></div>)

        }





        <div className='dueAll'>
          <div className='dueTitle' >
            <p className='text' onClick={() => dueHoliday()}>Urlop należny: {due - usedDue} / {due} dni</p>
            <span className='icon' onClick={() => setMenuDueDays(true)} ><AiOutlineAppstoreAdd /></span>
          </div>

          {menuDueDays ? (
            <div className='addOption'>
              <p>Urlop należny</p>
              <p onClick={() => setAddDueDays(true)}><IoMdAddCircle /><span>Dodaj</span></p>
              <p onClick={() => setEditDueDays(true)}><AiFillEdit /><span>Edytuj</span></p>
              <p onClick={() => setDeleteDueDays(true)}><AiFillDelete /><span>Usuń</span></p>
              <button onClick={() => setMenuDueDays(false)}>Cancel</button>
            </div>
          ) : (<div></div>)}

          <div id='due' className='due notVisible' >

            {updateDueDays.map((element) => <p className='dueOne' key={element.Id}> <span>{element.Holiday_name + ' ' + element.Name_Of_Child + ':' + ' '} {element.Days - element.UsedDays} / {element.Days + ' dni'}</span></p>)}


          </div>
        </div>

        {addDueDays ?
          (
            <form className='dueDays' onSubmit={(e) => { dueDays2(e) }}>
              <span className='icon' id='close' onClick={() => closeAddDueVacation()} ><AiOutlineClose /></span>
              <p>Dodaj należne dni urlopowe</p>
              <div>
                <label htmlFor='nameHoliday' id='nameDueHoliday'>Nazwa urlopu :</label>
              </div>
              <select name='listHolidays' id='listDueHolidays' onChange={(e) => (setDueDays(e.target.value), resetAlertDue())}>
                <option value="Zwykły urlop">Zwykły urlop</option>
                <option value="Urlop opiekuńczy">Urlop opiekuńczy</option>
                <option value="Urlop ojcowski">Urlop ojcowski</option>

              </select>
              {dueDays == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <input type="number" placeholder='Ilość dni' onChange={(e) => setNumberDueDays(e.target.value)} required />
                    </div>

                  </div>)
                :
                (<div></div>)
              }


              {dueDays == "Urlop opiekuńczy" ?

                (
                  <div>
                    <p>Ilość dni:</p>
                    <select name='numberOfDays' id='numberOfDays' onChange={(e) => setNumberDueDays(e.target.value)}>
                      <option value='2'>2 dni</option>
                      <option value='1'>1 dzień</option>
                    </select>



                  </div>)
                :
                (<div></div>)
              }

              {dueDays == "Urlop ojcowski" ?

                (
                  <div>
                    <p>Ilość dni:</p>
                    <select name='numberOfDays' id='numberOfDays' onChange={(e) => setNumberDueDays2(e.target.value)}>
                      <option value='10'>10 dni</option>
                      <option value='5'>5 dni</option>
                    </select>
                    <div>
                      <label htmlFor='nameOfChildDue' id='nameOfChildDue'>Imię dziecka:</label>
                      <input type="text" onChange={(e) => setNameOfChildDue(e.target.value)} />
                      <label htmlFor='nameDateOfBirthDue' id='nameDateOfBirthDue'>Data urodzenia dziecka:</label>
                      <input type="date" onChange={(e) => setDateOfBirth(e.target.value)} />
                    </div>
                  </div>)
                :
                (<div> </div>)
              }


              <button type='submit'>OK</button>
              <div id='alertDue'></div>
            </form>
          )
          :
          (<div></div>)

        }
        {editDueDays ?
          (
            <form className='editDueDays' onSubmit={(e) => { dueDaysEdit(e) }}>
              <span className='icon' id='closeEdit' onClick={() => (setEditDueDays(false))} ><AiOutlineClose /></span>
              <p>Edytuj należne dni urlopowe</p>

              {updateDueDays.length > 0 ?
                (<div>
                  <div>
                    <label htmlFor='nameHoliday' id='editNameDueHoliday'>Nazwa urlopu :</label>
                  </div>
                  <select name='editListHolidays' id='editListDueHolidays' onChange={(e) => editDueHoliday2(e)}>

                  </select>

                  {editNameDueDays == "Zwykły urlop" ?
                    (
                      <div>
                        <div>
                          <input type="number" value={editNumberDueDays} onChange={(e) => setEditNumberDueDays(e.target.value)} />
                        </div>

                      </div>)
                    :
                    (<div></div>)
                  }


                  {editNameDueDays == "Urlop ojcowski" ?
                    (<div>
                      <select name="nameOfChild" id='editNameOfChildDue2' onChange={(e) => editDueHoliday3(e)}>
                        {updateDueDays.map((element) => (

                          element.Holiday_name == 'Urlop ojcowski' &&
                          <option value={element.Id} key={element.Id}> {element.Name_Of_Child}</option>
                        )
                        )
                        }
                      </select>




                      <p>Ilość dni:</p>

                      <select name='editNumberOfDays' id='editNumberOfDays' value={editNumberDueDays2} onChange={(e) => setEditNumberDueDays2(e.target.value)}>
                        <option value='10'>10 dni</option>
                        <option value='5'>5 dni</option>
                      </select>
                      <label htmlFor='editNameOfChildDue' id='editNameOfChildDue'>Imię dziecka:</label>
                      <input type="text" value={editNameOfChildDue} onChange={(e) => setEditNameOfChildDue(e.target.value)} />
                      <label htmlFor='editNameDateOfBirthDue' id='editNameDateOfBirthDue'>Data urodzenia dziecka:</label>
                      <input type="date" value={editDateOfBirthDue} onChange={(e) => setEditDateOfBirthDue(e.target.value)} />
                    </div>)
                    :
                    (<div></div>)
                  }

                  {editNameDueDays == "Urlop opiekuńczy" ?

                    (
                      <div>
                        <p>Ilość dni:</p>
                        <select name='editNumberOfDays' id='editNumberOfDays' value={editNumberDueDays} onChange={(e) => setEditNumberDueDays(e.target.value)}>
                          <option value='2'>2 dni</option>
                          <option value='1'>1 dzień</option>
                        </select>

                      </div>)
                    :
                    (<div> </div>)
                  }

                  <button type='submit'>Edytuj</button>

                </div>)
                :
                (
                  <div className='noneDueDays'>Brak zaległych dni do edytowania</div>
                )
              }

            </form>
          )
          :
          (<div></div>)

        }
        {deleteDueDays ?
          (
            <form className='deleteDueDays' onSubmit={(e) => { dueDaysDelete(e) }}>
              <span className='icon' id='closeDelete' onClick={() => setDeleteDueDays(false)} ><AiOutlineClose /></span>
              <p>Usuń należne dni urlopowe</p>
              {updateDueDays.length > 0 ?
                (
                  <div>
                    <div>
                      <label htmlFor='nameHoliday' id='deleteNameDueHoliday'>Nazwa urlopu :</label>
                    </div>
                    <select name='deleteListHolidays' id='deleteListDueHolidays' onChange={(e) => deleteDueHoliday2(e)}>
                    </select>
                    {deleteNameDueDays == "Urlop ojcowski" ?
                      (<div>
                        <select name="nameOfChild" id='deleteNameOfChildDue2' onChange={(e) => deleteDueHoliday3(e)}>
                          {updateDueDays.map((element) => (

                            element.Holiday_name == 'Urlop ojcowski' &&
                            <option value={element.Id} key={element.Id}> {element.Name_Of_Child}</option>
                          )
                          )
                          }
                        </select>

                      </div>)
                      :
                      (<div></div>)
                    }



                    <button type='submit'>Usuń</button></div>
                ) : (
                  <div className='noneDueDays'>Brak naleznych dni do usunięcia</div>
                )

              }
            </form>
          )
          :
          (<div></div>)

        }




        <div className='plannedAll'>
          <div className='plannedTitle' >
            <p className='text' onClick={() => (plannedHoliday(), filtrerDoubleHolidayPlanned())}>Urlop planowany: {planned}</p>

          </div>
          <div id='planned' className='planned notVisible'>

            {
              plannedListName.map((element) => (

                <div key={element} className='plannedListNameHoliday'  >
                  <span> <p onClick={(e) => listPlannedHoliday(e)}>{element}</p>
                    <div id={element + ' ' + 'Planned'} className='listPlannedHoliday notVisible' >
                      {
                        plannedDownload.map((element2) => (
                          element2.Holiday_name == element &&
                          (
                            element2.Holiday_name == 'Urlop ojcowski' ? (

                              <p key={element2.Id}>{element2.Start_holiday} : {element2.End_holiday} - {element2.Name_Of_Child} <span onClick={() => (test(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days))}><AiFillEdit /></span><span onClick={() => (test2(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>



                            ) :
                              (
                                element2.Holiday_name == 'Urlop ojcowski' ? (
                                  <p key={element2.Id} >{element2.Start_holiday} : {element2.End_holiday} <span onClick={() => (test(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days,))}><AiFillEdit /></span><span onClick={() => (test2(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>
                                )
                                  :
                                  (<p key={element2.Id} >{element2.Start_holiday} : {element2.End_holiday} <span onClick={() => (test(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days,))}><AiFillEdit /></span><span onClick={() => (test2(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>
                                  )
                              ))
                        )
                        )

                      }



                    </div></span></div>
              )
              )

            }

          </div>
        </div>

        {
          addPlannedDays ?
            (
              <form className='plannedDays' onSubmit={(e) => { plannedDays2(e) }}>
                <span className='icon' id='closeAddPlanned' onClick={() => closeAddPlannedVacation()} ><AiOutlineClose /></span>
                <p>Dodaj planowane dni urlopowe</p>
                <div>
                  <label htmlFor='nameHoliday' className='holidayNamePlanned'>Nazwa urlopu :</label>
                </div>
                <select name='listHolidays' id='holidayListPlanned' className='holidayListPlanned' onChange={(e) => (setPlannedDaysName(e.target.value), resetAlertPlanned())}>

                </select>
                {plannedDaysName == "Zwykły urlop" ?

                  (
                    <div>
                      <div>
                        <p className='holidayNamePlanned'>Data początkowa:</p>
                        <input type='date' min={date} onChange={(e) => (setStartOfPlannedHolidays(e.target.value), resetAlertPlanned())} required></input>
                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Data końcowa:</p>
                        <input type='date' min={date} onChange={(e) => (setEndOfPlannedHolidays(e.target.value), resetAlertPlanned())} required  ></input>
                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Ilość dni:</p>
                        <input type="text" value={numbersOfDaysPlanned} readOnly />
                      </div>

                    </div>)
                  :
                  (<div></div>)
                }

                {plannedDaysName == "Urlop opiekuńczy" ?

                  (
                    <div>
                      <div>
                        <p className='holidayNamePlanned'>Data początkowa:</p>
                        <input type='date' min={date} onChange={(e) => (setStartOfPlannedHolidays(e.target.value), resetAlertPlanned())} required></input>
                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Data końcowa:</p>
                        <input type='date' min={date} onChange={(e) => (setEndOfPlannedHolidays(e.target.value), resetAlertPlanned())} required></input>
                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Ilość dni:</p>
                        <input type="text" value={numbersOfDaysPlanned} readOnly />
                      </div>
                    </div>)
                  :
                  (<div></div>)
                }
                {plannedDaysName == "Urlop ojcowski" ?
                  (
                    <div>
                      <div>
                        <label htmlFor='nameOfChildPlanned' className="nameOfChildPlanned" >Imię dziecka:</label>
                        <select name="nameOfChild" id='nameOfChildPlanned' className="nameOfChildPlanned" onChange={() => resetAlertPlanned()}>
                          {updateOverdueDays.map((element) => (

                            element.Holiday_name == 'Urlop ojcowski' &&
                            <option value={element.Name_Of_Child} key={element.Id}> {element.Name_Of_Child}</option>
                          )
                          )
                          }
                          {updateDueDays.map((element) =>
                            element.Holiday_name == 'Urlop ojcowski' &&
                            <option value={element.Name_Of_Child} key={element.Id}> {element.Name_Of_Child}</option>
                          )
                          }
                        </select>

                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Data początkowa:</p>
                        <input type='date' min={date} onChange={(e) => (setStartOfPlannedHolidays(e.target.value), resetAlertPlanned())} required></input>
                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Data końcowa:</p>
                        <input type='date' min={date} onChange={(e) => (setEndOfPlannedHolidays(e.target.value), resetAlertPlanned())} required></input>
                      </div>
                      <div>
                        <p className='holidayNamePlanned'>Ilość dni:</p>
                        <input type="text" value={numbersOfDaysPlanned} readOnly />
                      </div>
                    </div>)
                  :
                  (<div> </div>)
                }
                <div id='alertPlanned'></div>
                <div id='alertPlanned2'></div>
                <button type='submit'>OK</button>

              </form>
            )
            :
            (<div></div>)


        }

        {editPlannedDays ?
          (
            <form className='plannedDays' onSubmit={(e) => { editPlannedDays2(e) }}>
              <span className='icon' id='closeEditPlanned' onClick={() => closeEditPlannedVacation()} ><AiOutlineClose /></span>
              <p>Edytuj planowane dni urlopowe</p>


              {editPlannedDaysName == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {editPlannedDaysName}</p>
                    </div>

                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={editStartOfPlannedHolidays} onChange={(e) => (setEditStartOfPlannedHolidays(e.target.value), resetEditAlertPlanned())} required></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={editEndOfPlannedHolidays} onChange={(e) => (setEditEndOfPlannedHolidays(e.target.value), resetEditAlertPlanned())} required  ></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysPlanned} readOnly />
                    </div>

                  </div>)
                :
                (<div></div>)
              }

              {editPlannedDaysName == "Urlop opiekuńczy" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {editPlannedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={editStartOfPlannedHolidays} onChange={(e) => (setEditStartOfPlannedHolidays(e.target.value), resetEditAlertPlanned())} required></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={editEndOfPlannedHolidays} onChange={(e) => (setEditEndOfPlannedHolidays(e.target.value), resetEditAlertPlanned())} required></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysPlanned} readOnly />
                    </div>


                  </div>)
                :
                (<div></div>)
              }

              {editPlannedDaysName == "Urlop ojcowski" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {editPlannedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Imie dziecka:</p>
                      <p id='editNameOfChildPlanned' className='holidayNamePlanned'> {editNameOfChildPlanned}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={editStartOfPlannedHolidays} onChange={(e) => (setEditStartOfPlannedHolidays(e.target.value), resetEditAlertPlanned())} required></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={editEndOfPlannedHolidays} onChange={(e) => (setEditEndOfPlannedHolidays(e.target.value), resetEditAlertPlanned())} required></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysPlanned} readOnly />
                    </div>
                  </div>)
                :
                (<div> </div>)
              }
              <div id='editAlertPlanned'></div>
              <button type='submit'>OK</button>

            </form>
          )
          :
          (<div></div>)
        }

        {deletePlannedDays ?
          (
            <form className='plannedDays' onSubmit={(e) => { deletePlannedDays2(e) }}>
              <span className='icon' id='closeEditPlanned' onClick={() => setDeletePlannedDays(false)} ><AiOutlineClose /></span>
              <p>Usuń planowane dni urlopowe</p>

              {deletePlannedDaysName == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {deletePlannedDaysName}</p>
                    </div>

                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={deleteStartOfPlannedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={deleteEndOfPlannedHolidays} readOnly  ></input>
                    </div>


                  </div>)
                :
                (<div></div>)
              }

              {deletePlannedDaysName == "Urlop opiekuńczy" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {deletePlannedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={deleteStartOfPlannedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={deleteEndOfPlannedHolidays} readOnly></input>
                    </div>



                  </div>)
                :
                (<div></div>)
              }

              {deletePlannedDaysName == "Urlop ojcowski" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {deletePlannedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Imie dziecka:</p>
                      <p id='editNameOfChildPlanned' className='holidayNamePlanned'> {deleteNameOfChildPlanned}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={deleteStartOfPlannedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={deleteEndOfPlannedHolidays} readOnly></input>
                    </div>

                  </div>)
                :
                (<div> </div>)
              }
              <div id='editAlertPlanned'></div>
              <button type='submit'>OK</button>

            </form>
          )
          :
          (<div></div>)
        }

        <div className='usedAll'>
          <div className='usedTitle' onClick={() => (usedHoliday(), filtrerDoubleHolidayUsed())}>
            <p className='text'>Urlop wykorzystany: {used}</p>

            <p id='addUsedHoliday' onClick={() => setAddUsedDays(true)}><IoMdAddCircle /></p>

          </div>
          <div id='used' className=' used notVisible' >

            <div>
              <select name="listMonthUsedHoliday" id="listMonthUsedHoliday" value={listMonthUsedHoliday}
                onChange={(e) => setListMonthUsedHoliday(e.target.value)} >
                <option value="12">All</option>
                <option value="0">Styczeń</option>
                <option value="1">Luty</option>
                <option value="2">Marzec</option>
                <option value="3">Kwiecień</option>
                <option value="4">Maj</option>
                <option value="5">Czerwiec</option>
                <option value="6">Lipiec</option>
                <option value="7">Sierpień</option>
                <option value="8">Wrzesień</option>
                <option value="9">Październik</option>
                <option value="10">Listopad</option>
                <option value="11">Grudzień</option>
              </select>
              <select name="listYearUsedHoliday" id="listYearUsedHoliday" value={yearListOfHolidayUsed}
                onChange={(e) => setYearListOfHolidayUsed(e.target.value)}>

              </select>
            </div>
            {
              usedListName.map((element) => (

                <div key={element} className='usedListNameHoliday'  >
                  <span> <p onClick={(e) => listUsedHoliday(e)}>{element}</p>
                    <div id={element + ' ' + 'Used'} className='listUsedHoliday notVisible' >
                      {
                        usedDownload.map((element2) => (
                          element2.Holiday_name == element &&
                          (
                            (new Date(element2.Start_holiday).getFullYear() == Number(yearListOfHolidayUsed) || new Date(element2.End_holiday).getFullYear() == Number(yearListOfHolidayUsed)) &&
                            (listMonthUsedHoliday == '12' ?
                              (
                                element2.Holiday_name == 'Urlop ojcowski' ?
                                  (

                                    <p key={element2.Id}>{element2.Start_holiday} : {element2.End_holiday} - {element2.Name_Of_Child} <span onClick={() => (test3(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days))}><AiFillEdit /></span><span onClick={() => (test4(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>
                                  ) : (
                                    <p key={element2.Id} >{element2.Start_holiday} : {element2.End_holiday} <span onClick={() => (test3(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days,))}><AiFillEdit /></span><span onClick={() => (test4(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>
                                  )
                              )
                              :
                              (
                                (
                                  (new Date(element2.Start_holiday).getMonth() == Number(listMonthUsedHoliday) || new Date(element2.End_holiday).getMonth() == Number(listMonthUsedHoliday)) && (
                                    (
                                      element2.Holiday_name == 'Urlop ojcowski' ?
                                        (

                                          <p key={element2.Id}>{element2.Start_holiday} : {element2.End_holiday} - {element2.Name_Of_Child} <span onClick={() => (test3(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days))}><AiFillEdit /></span><span onClick={() => (test4(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>
                                        ) : (
                                          <p key={element2.Id} >{element2.Start_holiday} : {element2.End_holiday} <span onClick={() => (test3(element2.Id, element2.Holiday_name, element2.Start_holiday, element2.End_holiday, element2.Name_Of_Child, element2.All_Days, element2.Weeks_Days, element2.Weekend_Days, element2.Holiday_days,))}><AiFillEdit /></span><span onClick={() => (test4(element2.Id, element2.Name_Of_Child, element2.Holiday_name, element2.Start_holiday, element2.End_holiday))}> <AiFillDelete /></span></p>
                                        )
                                    )

                                  )
                                )
                              )

                            )



                          )
                        ))
                      }



                    </div>
                  </span>
                </div>
              )
              )

            }


          </div>

        </div>

        {
          addUsedDays ?
            (
              <form className='usedDays' onSubmit={(e) => { usedDays2(e) }}>
                <span className='icon' id='closeAddUsed' onClick={() => closeAddUsedVacation()} ><AiOutlineClose /></span>
                <p>Dodaj zużyte dni urlopowe</p>
                <div>
                  <label htmlFor='nameHoliday' className='holidayNameUsed'>Nazwa urlopu :</label>
                </div>
                <select name='listHolidays' id='holidayListUsed' className='holidayListUsed' onChange={(e) => (setUsedDaysName(e.target.value), resetAlertUsed())}>

                </select>
                {usedDaysName == "Zwykły urlop" ?

                  (
                    <div>
                      <div>
                        <p className='holidayNameUsed'>Data początkowa:</p>
                        <input type='date' onChange={(e) => (setStartOfUsedHolidays(e.target.value), resetAlertUsed())} required></input>
                      </div>
                      <div>
                        <p className='holidayNameUsed'>Data końcowa:</p>
                        <input type='date' onChange={(e) => (setEndOfUsedHolidays(e.target.value), resetAlertUsed())} required  ></input>
                      </div>
                      <div>
                        <p className='holidayNameUsed'>Ilość dni:</p>
                        <input type="text" value={numbersOfDaysUsed} readOnly />
                      </div>

                    </div>)
                  :
                  (<div></div>)
                }

                {usedDaysName == "Urlop opiekuńczy" ?

                  (
                    <div>
                      <div>
                        <p className='holidayNameUsed'>Data początkowa:</p>
                        <input type='date' onChange={(e) => (setStartOfUsedHolidays(e.target.value), resetAlertUsed())} required></input>
                      </div>
                      <div>
                        <p className='holidayNameUsed'>Data końcowa:</p>
                        <input type='date' onChange={(e) => (setEndOfUsedHolidays(e.target.value), resetAlertUsed())} required></input>
                      </div>
                      <div>
                        <p className='holidayNameUsed'>Ilość dni:</p>
                        <input type="text" value={numbersOfDaysUsed} readOnly />
                      </div>
                    </div>)
                  :
                  (<div></div>)
                }
                {usedDaysName == "Urlop ojcowski" ?
                  (
                    <div>
                      <div>
                        <label htmlFor='nameOfChildUsed' className="nameOfChildUsed" >Imię dziecka:</label>
                        <select name="nameOfChild" id='nameOfChildUsed' className="nameOfChildUsed" onChange={() => resetAlertUsed()}>
                          {updateOverdueDays.map((element) => (

                            element.Holiday_name == 'Urlop ojcowski' &&
                            <option value={element.Name_Of_Child} key={element.Id}> {element.Name_Of_Child}</option>
                          )
                          )
                          }
                          {updateDueDays.map((element) =>
                            element.Holiday_name == 'Urlop ojcowski' &&
                            <option value={element.Name_Of_Child} key={element.Id}> {element.Name_Of_Child}</option>
                          )
                          }
                        </select>

                      </div>
                      <div>
                        <p className='holidayNameUsed'>Data początkowa:</p>
                        <input type='date' onChange={(e) => (setStartOfUsedHolidays(e.target.value), resetAlertUsed())} required></input>
                      </div>
                      <div>
                        <p className='holidayNameUsed'>Data końcowa:</p>
                        <input type='date' onChange={(e) => (setEndOfUsedHolidays(e.target.value), resetAlertUsed())} required></input>
                      </div>
                      <div>
                        <p className='holidayNameUsed'>Ilość dni:</p>
                        <input type="text" value={numbersOfDaysUsed} readOnly />
                      </div>
                    </div>)
                  :
                  (<div> </div>)
                }
                <div id='alertUsed'></div>
                <button type='submit'>OK</button>

              </form>
            )
            :
            (<div></div>)


        }
        {editUsedDays ?
          (
            <form className='usedDays' onSubmit={(e) => { editUsedDays2(e) }}>
              <span className='icon' id='closeEditUsed' onClick={() => closeEditUsedVacation()} ><AiOutlineClose /></span>
              <p>Edytuj wykorzystane dni urlopowe</p>


              {editUsedDaysName == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <p className='holidayNameUsed'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNameUsed'> {editUsedDaysName}</p>
                    </div>

                    <div>
                      <p className='holidayNameUsed'>Data początkowa:</p>
                      <input type='date' value={editStartOfUsedHolidays} onChange={(e) => (setEditStartOfUsedHolidays(e.target.value), resetEditAlertUsed())} required></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data końcowa:</p>
                      <input type='date' value={editEndOfUsedHolidays} onChange={(e) => (setEditEndOfUsedHolidays(e.target.value), resetEditAlertUsed())} required  ></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysUsed} readOnly />
                    </div>

                  </div>)
                :
                (<div></div>)
              }

              {editUsedDaysName == "Urlop opiekuńczy" ?

                (
                  <div>
                    <div>
                      <p className='holidayNameUsed'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNameUsed'> {editUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={editStartOfUsedHolidays} onChange={(e) => (setEditStartOfUsedHolidays(e.target.value), resetEditAlertUsed())} required></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data końcowa:</p>
                      <input type='date' value={editEndOfUsedHolidays} onChange={(e) => (setEditEndOfUsedHolidays(e.target.value), resetEditAlertUsed())} required></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysUsed} readOnly />
                    </div>


                  </div>)
                :
                (<div></div>)
              }

              {editUsedDaysName == "Urlop ojcowski" ?

                (
                  <div>
                    <div>
                      <p className='holidayNameUsed'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNameUsed'> {editUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Imie dziecka:</p>
                      <p id='editNameOfChildUsed' className='holidayNameUsed'> {editNameOfChildUsed}</p>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data początkowa:</p>
                      <input type='date' value={editStartOfUsedHolidays} onChange={(e) => (setEditStartOfUsedHolidays(e.target.value), resetEditAlertUsed())} required></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data końcowa:</p>
                      <input type='date' value={editEndOfUsedHolidays} onChange={(e) => (setEditEndOfUsedHolidays(e.target.value), resetEditAlertUsed())} required></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysUsed} readOnly />
                    </div>
                  </div>)
                :
                (<div> </div>)
              }
              <div id='editAlertUsed'></div>
              <button type='submit'>OK</button>

            </form>
          )
          :
          (<div></div>)
        }

        {deleteUsedDays ?
          (
            <form className='usedDays' onSubmit={(e) => { deleteUsedDays2(e) }}>
              <span className='icon' id='closeEditUsed' onClick={() => setDeleteUsedDays(false)} ><AiOutlineClose /></span>
              <p>Usuń wykorzystane dni urlopowe</p>

              {deleteUsedDaysName == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <p className='holidayNameUsed'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNameUsed'> {deleteUsedDaysName}</p>
                    </div>

                    <div>
                      <p className='holidayNameUsed'>Data początkowa:</p>
                      <input type='date' value={deleteStartOfUsedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data końcowa:</p>
                      <input type='date' value={deleteEndOfUsedHolidays} readOnly  ></input>
                    </div>


                  </div>)
                :
                (<div></div>)
              }

              {deleteUsedDaysName == "Urlop opiekuńczy" ?

                (
                  <div>
                    <div>
                      <p className='holidayNameUsed'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNameUsed'> {deleteUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data początkowa:</p>
                      <input type='date' value={deleteStartOfUsedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data końcowa:</p>
                      <input type='date' value={deleteEndOfUsedHolidays} readOnly></input>
                    </div>



                  </div>)
                :
                (<div></div>)
              }

              {deleteUsedDaysName == "Urlop ojcowski" ?

                (
                  <div>
                    <div>
                      <p className='holidayNameUsed'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNameUsed'> {deleteUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Imie dziecka:</p>
                      <p id='editNameOfChildUsed' className='holidayNameUsed'> {deleteNameOfChildUsed}</p>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data początkowa:</p>
                      <input type='date' value={deleteStartOfUsedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNameUsed'>Data końcowa:</p>
                      <input type='date' value={deleteEndOfUsedHolidays} readOnly></input>
                    </div>

                  </div>)
                :
                (<div> </div>)
              }
              <div id='deleteAlertUsed'></div>
              <button type='submit'>OK</button>

            </form>
          )
          :
          (<div></div>)
        }

        {alertUsedDays ?
          (
            <form className='plannedDays' onSubmit={(e) => { usedPlannedDays(e) }}>

              <p>Czy poniższy urlop został wykorzystany?</p>

              {alertUsedDaysName == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {alertUsedDaysName}</p>
                    </div>

                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={alertUsedStartOfPlannedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={alertUsedEndOfPlannedHolidays} readOnly  ></input>
                    </div>


                  </div>)
                :
                (<div></div>)
              }

              {alertUsedDaysName == "Urlop opiekuńczy" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {alertUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={alertUsedStartOfPlannedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={alertUsedEndOfPlannedHolidays} readOnly></input>
                    </div>



                  </div>)
                :
                (<div></div>)
              }

              {alertUsedDaysName == "Urlop ojcowski" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {alertUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Imie dziecka:</p>
                      <p id='editNameOfChildPlanned' className='holidayNamePlanned'> {alertUsedNameOfChildPlanned}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={alertUsedStartOfPlannedHolidays} readOnly></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={alertUsedEndOfPlannedHolidays} readOnly></input>
                    </div>

                  </div>)
                :
                (<div> </div>)
              }

              <button type='submit'>TAK</button>
              <button type='button' onClick={(e) => deleteUsedPlannedDays(e)}>NIE</button>
              <button type='button' onClick={(e) => (editUsedPlannedDaysAlert(e))}>Edytuj</button>
            </form>
          )
          :
          (<div></div>)
        }

        {editUsedPlannedDays ?

          (
            <form className='plannedDays' onSubmit={(e) => { usedPlannedDaysEdit(e) }}>
              <div>
                <FontAwesomeIcon id='faArrowLeft' icon={faArrowLeft} onClick={() => (updateDataUsedAfterCancelation(), setEditUsedPlannedDays(false))} />
                <p>Edytuj urlop wykorzystany?</p>
              </div>


              {alertUsedDaysName == "Zwykły urlop" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {alertUsedDaysName}</p>
                    </div>

                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={alertUsedStartOfPlannedHolidays} onChange={(e) => (setAlertUsedStartOfPlannedHolidays(e.target.value))} ></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={alertUsedEndOfPlannedHolidays} onChange={(e) => (setAlertUsedEndOfPlannedHolidays(e.target.value))}  ></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysPlannedAlert} readOnly />
                    </div>

                  </div>)
                :
                (<div></div>)
              }

              {alertUsedDaysName == "Urlop opiekuńczy" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {alertUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={alertUsedStartOfPlannedHolidays} onChange={(e) => (setAlertUsedStartOfPlannedHolidays(e.target.value))} ></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={alertUsedEndOfPlannedHolidays} onChange={(e) => (setAlertUsedEndOfPlannedHolidays(e.target.value))} ></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysPlannedAlert} readOnly />
                    </div>


                  </div>)
                :
                (<div></div>)
              }

              {alertUsedDaysName == "Urlop ojcowski" ?

                (
                  <div>
                    <div>
                      <p className='holidayNamePlanned'>Nazwa urlopu:</p>
                      <p id='editName' className='holidayNamePlanned'> {alertUsedDaysName}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Imie dziecka:</p>
                      <p id='editNameOfChildPlanned' className='holidayNamePlanned'> {alertUsedNameOfChildPlanned}</p>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data początkowa:</p>
                      <input type='date' value={alertUsedStartOfPlannedHolidays} onChange={(e) => (setAlertUsedStartOfPlannedHolidays(e.target.value))}></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Data końcowa:</p>
                      <input type='date' value={alertUsedEndOfPlannedHolidays} onChange={(e) => (setAlertUsedEndOfPlannedHolidays(e.target.value))} ></input>
                    </div>
                    <div>
                      <p className='holidayNamePlanned'>Ilość dni:</p>
                      <input type="text" value={editNumbersOfDaysPlannedAlert} readOnly />
                    </div>

                  </div>)
                :
                (<div> </div>)
              }
              <p id='editUsedAlertPlanned'></p>
              <p id='editUsedAlertPlanned2'></p>
              <button type='submit' >OK</button>

            </form>
          ) : (<div></div>)
        }


        <div className='remainingAll'>
          <div className='remainingTitle' onClick={() => remainingHoliday()}>
            <p className='text'>Urlop pozostały: {remaining}</p>
          </div>
          <div id='remaining' className=' remaining notVisible' >
            <p className='remainingOne'><span>Dni pozostałe:</span></p>

          </div>
        </div>



        <div className='holidaysAll'>
          <div className='holidaysTitle' >
            <p className='text' onClick={() => listHolidays()}>Dni świąteczne:  </p>

          </div>

          <div id='holidayList' className=' holidays notVisible' >
            <p className='holidaysOne'><span>Dni podstawowe:</span></p>
            <div className='holidaysList'>
              <div id='selectYear'>
                <select name="year" id="yearOfHoliday" value={yearListOfHoliday} onChange={e => setYearListOfHoliday(e.target.value)}>
                </select>
              </div>

              {holidayDays3.map((element) => (
                element.User == 'Together' && (
                  (new Date(element.Holiday_date)).getDay() === 6 ?
                    (<p className='greenDate' key={Math.random().toString()}>{element.Holiday_date + ' : ' + element.Name}</p>)
                    :
                    (<p key={Math.random().toString()}>{element.Holiday_date + ' : ' + element.Name}</p>)

                )

              ))}

            </div>



            <p className='holidaysOne'><span>{userName}</span>  <span className='icon' onClick={() => setMenuHolidays(true)} ><AiOutlineAppstoreAdd /></span></p>
            {menuHolidays ? (
              <div className='addOption'>
                <p>Święto wypadające w sobotę</p>
                <p onClick={() => (setAddUserHoliday(true), setMenuHolidays(false))}><IoMdAddCircle /><span>Dodaj</span></p>
                <p onClick={() => editUserHolidays()}><AiFillEdit /><span>Edytuj</span></p>
                <p id='alertEditHoliday'></p>
                <button onClick={() => setMenuHolidays(false)}>Cancel</button>

              </div>
            ) : (<div></div>)}



            <div className='holidaysList'>
              {holidayDays3.map((element) => (
                element.User == userName &&
                <p key={Math.random().toString()}>{element.Holiday_date + ' => '} {<span className='greenDate'> {element.Date} </span>}  {' : ' + element.Name}</p>
              ))}
            </div>
          </div>

          {addUserHoliday ?
            (
              <form className='userHoliday' onSubmit={(e) => userHoliday(e)}>

                <span className='icon' id='close' onClick={() => setAddUserHoliday(false)} ><AiOutlineClose /></span>

                <p>Święto przepadające w sobotę</p>

                <div>
                  <p className='holidayName'>Data święta:</p>
                  <div id='selectDate'>
                    <select id='listUserHolidays' ></select>

                  </div>

                </div>
                <div>
                  <p className='holidayName'>Data oddania:</p>
                  <input type='date' onChange={(e) => setUserDate(e.target.value)} required></input>
                </div>
                <button type='submit'>OK</button>
                <div id='alert2'></div>
              </form>
            ) : (<div></div>)}


          {editUserHoliday ?
            (
              <form className='userHoliday' onSubmit={(e) => userHoliday2(e)}>

                <span className='icon' id='close' onClick={() => setEditUserHoliday(false)} ><AiOutlineClose /></span>

                <p>Święto przepadające w sobotę</p>

                <div>
                  <p className='holidayName'>Data święta:</p>
                  <div id='selectDate'>
                    <select id='editListUserHolidays' onChange={() => (changeDateHoliday())} ></select>

                  </div>

                </div>
                <div>
                  <p className='holidayName'>Data oddania:</p>
                  <input value={editUserDate} type='date' onChange={(e) => setEditUserDate(e.target.value)}></input>
                </div>
                <button type='submit'>OK</button>

              </form>
            ) : (<div></div>)}
        </div>


      </div >
      <button onClick={() => addUser()}>Add user</button>
      <footer>
        <button type='button' onClick={(e) => setAddPlannedDays(true)} id='circle'><p>+</p></button>
      </footer>
    </div >
  )
}

export default Holiday